module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("angular");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(46);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(12),
    isLength = __webpack_require__(7),
    isObjectLike = __webpack_require__(3);

/** `Object#toString` result references. */
var arrayTag = '[object Array]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

module.exports = isArray;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var getLength = __webpack_require__(39),
    isLength = __webpack_require__(7);

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

module.exports = isArrayLike;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("angular-ui-router");

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(6),
    isIndex = __webpack_require__(10),
    isObject = __webpack_require__(4);

/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
      ? (isArrayLike(object) && isIndex(index, object.length))
      : (type == 'string' && index in object)) {
    var other = object[index];
    return value === value ? (value === other) : (other !== other);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(12),
    isArrayLike = __webpack_require__(6),
    isObject = __webpack_require__(4),
    shimKeys = __webpack_require__(92);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

module.exports = keys;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var isNative = __webpack_require__(91);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(6),
    isObjectLike = __webpack_require__(3);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Native method references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is classified as an `arguments` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  return isObjectLike(value) && isArrayLike(value) &&
    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
}

module.exports = isArguments;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(25),
    baseLodash = __webpack_require__(15);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
 * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
 */
function LodashWrapper(value, chainAll, actions) {
  this.__wrapped__ = value;
  this.__actions__ = actions || [];
  this.__chain__ = !!chainAll;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/**
 * The function whose prototype all chaining wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(25),
    baseLodash = __webpack_require__(15);

/** Used as references for `-Infinity` and `Infinity`. */
var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = POSITIVE_INFINITY;
  this.__views__ = [];
}

LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

module.exports = baseToString;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_button_module__ = __webpack_require__(47);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__u_button_module__["a"]; });


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UFaIconComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_fa_icon_component__ = __webpack_require__(72);



var UFaIconComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-fa-icon', []).component('uFaIcon', __WEBPACK_IMPORTED_MODULE_1__u_fa_icon_component__["a" /* UFaIconComponent */]);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 which returns 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

module.exports = isFunction;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function restParam(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        rest = Array(length);

    while (++index < length) {
      rest[index] = args[start + index];
    }
    switch (start) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, args[0], rest);
      case 2: return func.call(this, args[0], args[1], rest);
    }
    var otherArgs = Array(start + 1);
    index = -1;
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = rest;
    return func.apply(this, otherArgs);
  };
}

module.exports = restParam;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dynamic_filter__ = __webpack_require__(110);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dynamic_filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__phone_number__ = __webpack_require__(112);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__phone_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduce_to_property__ = __webpack_require__(114);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__reduce_to_property__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__titleize__ = __webpack_require__(116);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__titleize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zip_code__ = __webpack_require__(118);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__zip_code__["a"]; });






/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UToastComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_fa_icon__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_toast_directive__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__u_toast_service__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__u_toast_global_css__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__u_toast_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__u_toast_global_css__);






var UToastComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-toast', [__WEBPACK_IMPORTED_MODULE_1__u_fa_icon__["a" /* UFaIconComponent */].name, __WEBPACK_IMPORTED_MODULE_2__u_toast_directive__["a" /* UToastDirective */].name, __WEBPACK_IMPORTED_MODULE_3__u_toast_service__["a" /* UToastService */].name]);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_TOAST_EVENT; });
var SHOW_TOAST_EVENT = 'u-toast.events.show-toast';

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(prototype) {
    if (isObject(prototype)) {
      object.prototype = prototype;
      var result = new object;
      object.prototype = undefined;
    }
    return result || {};
  };
}());

module.exports = baseCreate;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(175),
    noop = __webpack_require__(177);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(178);

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = array ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeAddress;
function normalizeAddress(address) {
  address = address || {};

  return {
    address1: address.street || address.address1,
    address2: address.apt || address.address2,
    address3: address.address3,
    address4: address.address4,
    city: address.city,
    state: address.state || address.state_province,
    zip: address.zip || address.zip_postal_code
  };
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(30);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UBreadcrumbComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UButtonGroupComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UChecklistComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UCtaCardComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UErrorPageComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UFaIconComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UFooterComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UProviderCardComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UTableComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UToastComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UButtonComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "GaugeModule", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters__ = __webpack_require__(22);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DynamicFilter", function() { return __WEBPACK_IMPORTED_MODULE_1__filters__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PhoneNumberFilter", function() { return __WEBPACK_IMPORTED_MODULE_1__filters__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ReduceToPropertyFilter", function() { return __WEBPACK_IMPORTED_MODULE_1__filters__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TitleizeFilter", function() { return __WEBPACK_IMPORTED_MODULE_1__filters__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ZipCodeFilter", function() { return __WEBPACK_IMPORTED_MODULE_1__filters__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__(142);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "globals", function() { return __WEBPACK_IMPORTED_MODULE_2__globals__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(144);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BindCompileHelper", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ClickOutsideModule", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ULoadingHelper", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UErrorCodes", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "UNotifyHelper", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "URedirectHelper", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ChangeModule", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LoadingOverlayModule", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(167);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_4__styles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(169);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatAddress", function() { return __WEBPACK_IMPORTED_MODULE_5__utils__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatUnnormalizedAddress", function() { return __WEBPACK_IMPORTED_MODULE_5__utils__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "formatZip", function() { return __WEBPACK_IMPORTED_MODULE_5__utils__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "normalizeAddress", function() { return __WEBPACK_IMPORTED_MODULE_5__utils__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "centeredRange", function() { return __WEBPACK_IMPORTED_MODULE_5__utils__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mod", function() { return __WEBPACK_IMPORTED_MODULE_5__utils__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validators__ = __webpack_require__(188);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "InputEmailValidator", function() { return __WEBPACK_IMPORTED_MODULE_6__validators__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ZipCodeValidator", function() { return __WEBPACK_IMPORTED_MODULE_6__validators__["b"]; });








/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_breadcrumb__ = __webpack_require__(31);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__u_breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_button__ = __webpack_require__(18);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__u_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_button_group__ = __webpack_require__(52);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__u_button_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__u_checklist__ = __webpack_require__(57);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__u_checklist__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__u_cta_card__ = __webpack_require__(62);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__u_cta_card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__u_error_page__ = __webpack_require__(67);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__u_error_page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__u_fa_icon__ = __webpack_require__(19);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__u_fa_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__u_footer__ = __webpack_require__(76);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__u_footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gauge__ = __webpack_require__(84);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__gauge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__u_provider_card__ = __webpack_require__(104);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__u_provider_card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__u_table__ = __webpack_require__(123);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__u_table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__u_toast__ = __webpack_require__(23);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__u_toast__["a"]; });













/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UBreadcrumbComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_ui_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_breadcrumb_builder__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__u_breadcrumb_component__ = __webpack_require__(41);





var UBreadcrumbComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-breadcrumb', [__WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default.a, __WEBPACK_IMPORTED_MODULE_2__u_breadcrumb_builder__["a" /* UBreadcrumbBuilderService */].name]).component('uBreadcrumb', __WEBPACK_IMPORTED_MODULE_3__u_breadcrumb_component__["a" /* UBreadcrumbComponent */]);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UBreadcrumbBuilderService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_ui_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_breadcrumb_builder_service__ = __webpack_require__(33);




var UBreadcrumbBuilderService = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-breadcrumb.builder', [__WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default.a]).service('UBreadcrumbBuilder', __WEBPACK_IMPORTED_MODULE_2__u_breadcrumb_builder_service__["a" /* UBreadcrumbBuilderService */]);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UBreadcrumbBuilderService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_string_startCase__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_string_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_string_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/*
  UBreadcrumbBuilder

  A utility class for building the breadcrumbs array

  How it works:
    The breadcrumbs are built based on a hierarchy structure (parent / child relationship).
    It is assumed that all states inherit from it's parent and that the states are named
    appropriately (for the most part) in a manner that makes sense to display.

    For example if you have these states:
      - app (abstract state)
      - app.parent
      - app.parent.child
      - app.parent.child.add-child

    And the user is currently on 'app.parent.child.add-child', then the breadcrumb
    that would be displayed would like like this:

      Parent > Child > Add Child

   As you can see from the above example, abstract states are ignored (you can also
   explicitly skip states by defining a 'breadcrumb' object on the state definition)

  Example Definition:

    $stateProvider
      .state('app.parent', {
        abstract: true
      })
      .state('app.parent', {
        url: '/parent',
        breadcrumb: {
          display: 'Parent State'
        }
      })
      .state('app.parent.child', {
        url: '/parent',
        breadcrumb: {
          skip: true
        }
      })
      .state('app.parent.child.add-child', {
        url: '/parent'
      })

    The above would produce a breadcrumb that looks like this:
      Parent State > Add Child
 */
var UBreadcrumbBuilderService = function () {
  UBreadcrumbBuilderService.$inject = ['$state', '$injector', '$interpolate'];

  function UBreadcrumbBuilderService($state, $injector, $interpolate) {
    'ngInject';

    _classCallCheck(this, UBreadcrumbBuilderService);

    Object.assign(this, { $state: $state, $injector: $injector, $interpolate: $interpolate });
    this.initializeBreadcrumbs();
  }

  _createClass(UBreadcrumbBuilderService, [{
    key: 'addBreadcrumb',
    value: function addBreadcrumb(state) {
      this.breadcrumbs.push({
        display: this.getDisplayName(state),
        state: state.name,
        uiSref: this.getUiSref(state)
      });
    }
  }, {
    key: 'build',
    value: function build(currentState) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Always reinitialize the states array
      this.initializeBreadcrumbs();

      // If an initial-state is defined, then add it
      var initialState = options.initialState;
      if (initialState && this.isDefinedState(initialState)) {
        this.addBreadcrumb(this.getDefinedState(initialState));
      }

      // Iterate over each level of states until we hit the root, evaluating whether the
      // state should be included in the breadcrumbs
      var stateLevels = (currentState.name || '').split('.');
      stateLevels.forEach(function (level, index) {
        level = stateLevels.slice(0, index + 1).join('.');
        var state = _this.getDefinedState(level);
        var isDefinedState = state && _this.isDefinedState(state.name);

        // Skip states that are:
        //  - not ui-router states (can assume this, but just in case)
        //  - abstract and not included explicitly via a state definition
        //  - explicitly skiped via a state definition
        //  - duplicates
        if (isDefinedState && _this.shouldAdd(state) && !_this.isDuplicateBreadcrumb(state)) {
          _this.addBreadcrumb(state);
        }
      });

      return this.breadcrumbs;
    }
  }, {
    key: 'getDefinedState',
    value: function getDefinedState(stateName) {
      return this.getDefinedStates().find(function (state) {
        return state.name === stateName;
      });
    }
  }, {
    key: 'getDisplayName',
    value: function getDisplayName(state) {
      var display = state.breadcrumb && state.breadcrumb.display;

      if (display) {
        // Allow strings to be interpolated
        if (__WEBPACK_IMPORTED_MODULE_1_angular___default.a.isString(display)) {
          display = this.$interpolate(display)(this);
        } else if (__WEBPACK_IMPORTED_MODULE_1_angular___default.a.isArray(display) || __WEBPACK_IMPORTED_MODULE_1_angular___default.a.isFunction(display)) {
          // Handle an annotated / DI function (Array)
          // Handle a regular (non-DI / non-annotated) function
          display = this.$injector.invoke(display);
        }
      }

      return display || titleize(state.name);
    }
  }, {
    key: 'initializeBreadcrumbs',
    value: function initializeBreadcrumbs() {
      this.breadcrumbs = [];
    }
  }, {
    key: 'isDuplicateBreadcrumb',
    value: function isDuplicateBreadcrumb(state) {
      return !!this.breadcrumbs.find(function (crumb) {
        return crumb.state === state.name;
      });
    }
  }, {
    key: 'isDefinedState',
    value: function isDefinedState(stateName) {
      return !!this.getDefinedStates().find(function (state) {
        return state.name === stateName;
      });
    }
  }, {
    key: 'getUiSref',
    value: function getUiSref(state) {
      var breadcrumb = state.breadcrumb || {};
      return breadcrumb.uiSref || state.name;
    }

    // Gets all the uiRouter defined states

  }, {
    key: 'getDefinedStates',
    value: function getDefinedStates() {
      return this.$state.get();
    }
  }, {
    key: 'shouldAdd',
    value: function shouldAdd(state) {
      var breadcrumb = state.breadcrumb || {};
      return !state.abstract && !breadcrumb.skip || !!state.abstract && breadcrumb.hasOwnProperty('skip') && !breadcrumb.skip;
    }
  }]);

  return UBreadcrumbBuilderService;
}();

// Converts a state name from 'aaa.bbb.ccc-ddd' to 'Ccc Ddd'
function titleize() {
  var stateName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return __WEBPACK_IMPORTED_MODULE_0_lodash_string_startCase___default()(stateName.split('.').pop());
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(35);

/**
 * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__foo_bar__');
 * // => 'Foo Bar'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
});

module.exports = startCase;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var deburr = __webpack_require__(36),
    words = __webpack_require__(38);

/**
 * Creates a function that produces compound words out of the words in a
 * given string.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    var index = -1,
        array = words(deburr(string)),
        length = array.length,
        result = '';

    while (++index < length) {
      result = callback(result, array[index], index);
    }
    return result;
  };
}

module.exports = createCompounder;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(17),
    deburrLetter = __webpack_require__(37);

/** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

/** Used to match latin-1 supplementary letters (excluding mathematical operators). */
var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

/**
 * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = baseToString(string);
  return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/** Used to map latin-1 supplementary letters to basic latin letters. */
var deburredLetters = {
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss'
};

/**
 * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
function deburrLetter(letter) {
  return deburredLetters[letter];
}

module.exports = deburrLetter;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(17),
    isIterateeCall = __webpack_require__(9);

/** Used to match words to create compound words. */
var reWords = (function() {
  var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
      lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

  return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
}());

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  if (guard && isIterateeCall(string, pattern, guard)) {
    pattern = undefined;
  }
  string = baseToString(string);
  return string.match(pattern || reWords) || [];
}

module.exports = words;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(40);

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

module.exports = getLength;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UBreadcrumbComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_breadcrumb_html__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_breadcrumb_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_breadcrumb_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_breadcrumb_controller__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_breadcrumb_global_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_breadcrumb_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__u_breadcrumb_global_css__);




var UBreadcrumbComponent = {
  controller: __WEBPACK_IMPORTED_MODULE_1__u_breadcrumb_controller__["a" /* UBreadcrumbController */],
  template: __WEBPACK_IMPORTED_MODULE_0__u_breadcrumb_html___default.a,
  bindings: {
    divider: '@',
    initialState: '@'
  }
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"u-breadcrumb\">\n  <li ng-repeat=\"breadcrumb in $ctrl.breadcrumbs\">\n    <a ui-sref=\"{{breadcrumb.uiSref}}\" ng-if=\"!$last\">{{breadcrumb.display}}</a>\n    <span ng-if=\"$last\" ng-class=\"{'disabled': $last}\">{{breadcrumb.display}}</span>\n    <span ng-if=\"!$last\" class=\"divider\">{{$ctrl.divider || '&gt'}}</span>\n  </li>\n</ul>\n"

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UBreadcrumbController; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UBreadcrumbController =
// Only using $state here since we have to listen for $stateChangeSuccess
function UBreadcrumbController($scope, $state, UBreadcrumbBuilder) {
  'ngInject';

  var _this = this;

  _classCallCheck(this, UBreadcrumbController);

  this.breadcrumbs = [];

  $scope.$on('$stateChangeSuccess', function (event, currentState) {
    _this.breadcrumbs = UBreadcrumbBuilder.build(currentState, {
      initialState: _this.initialState
    });
  });
};
UBreadcrumbController.$inject = ['$scope', '$state', 'UBreadcrumbBuilder'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(45);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-breadcrumb.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-breadcrumb.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".u-breadcrumb {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n.u-breadcrumb li {\n  display: inline;\n  font-size: 12px;\n  color: #2b7499;\n}\n.u-breadcrumb li .disabled {\n  color: #8c8c8d;\n}\n.u-breadcrumb li .divider {\n  padding: 7px;\n}\n", ""]);

// exports


/***/ }),
/* 46 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	var fixedCss = css.replace(/url *\( *(.+?) *\)/g, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UButtonComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_button_component__ = __webpack_require__(48);



var UButtonComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-button', []).component('uButton', __WEBPACK_IMPORTED_MODULE_1__u_button_component__["a" /* UButtonComponent */]);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UButtonController */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UButtonComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_button_html__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_button_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_button_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_button_global_css__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_button_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__u_button_global_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ALLOWED_TYPES = ['button', 'submit', 'reset'];

var UButtonController = function () {
  UButtonController.$inject = ['$window', '$element', '$transclude'];

  function UButtonController($window, $element, $transclude) {
    'ngInject';

    _classCallCheck(this, UButtonController);

    this.$window = $window;
    this.$element = $element;
    this.$transclude = $transclude;
  }

  _createClass(UButtonController, [{
    key: '$onChanges',
    value: function $onChanges(changes) {
      var disabled = changes.disabled;

      if (disabled) {
        this._handleDisabledChange(disabled.currentValue);
      }
    }
  }, {
    key: '_handleDisabledChange',
    value: function _handleDisabledChange(value) {
      var buttonEl = this.$element.find('button')[0];

      if (value && this.disabledText) {
        buttonEl.innerHTML = this.disabledText;
      } else {
        // This is performing manual transclusion for finer grained control
        this.$transclude(function (transEl) {
          buttonEl.innerHTML = '';
          buttonEl.appendChild(transEl[0]);
        });
      }
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      if (this.ngHref && !this.disabled) {
        this.$window.open(this.ngHref, '_blank');
      }
    }
  }, {
    key: 'ariaDisabled',
    get: function () {
      return this.disabled ? 'true' : 'false';
    }
  }, {
    key: 'buttonType',
    get: function () {
      return ALLOWED_TYPES.indexOf(this.type) > -1 ? this.type : 'button';
    }
  }]);

  return UButtonController;
}();

var UButtonComponent = {
  transclude: true,
  template: __WEBPACK_IMPORTED_MODULE_0__u_button_html___default.a,
  controller: UButtonController,
  bindings: {
    type: '@?',
    // REVIEW: Should u-button support an `href` since the element should
    //         really be an <a> tag?
    ngHref: '@?',
    disabled: '<?',
    disabledText: '@?'
  }
};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "<button\n  type=\"{{$ctrl.buttonType}}\"\n  ng-click=\"$ctrl.onClick()\"\n  ng-disabled=\"$ctrl.disabled\"\n  aria-disabled=\"{{$ctrl.ariaDisabled}}\"\n>\n  <ng-transclude></ng-transclude>\n</button>\n"

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-button.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-button.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "u-button {\n  display: inline-block;\n}\nu-button button {\n  background-color: #2b7499;\n  color: #ffffff;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  outline: 0;\n  font-weight: 200;\n  border: 1px solid transparent;\n  cursor: pointer;\n  border-radius: 3px;\n  font-size: 14px;\n  line-height: 1.8;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  padding: 12px 24px;\n  width: 100%;\n  height: 100%\n}\nu-button button:disabled {\n  text-shadow: none;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\nu-button button:hover:not(:disabled) {\n  background-color: #3692c1;\n}\nu-button[tertiary] button {\n  color: #2b7499;\n  background-color: #ffffff;\n  border-color: #80acc2;\n}\nu-button[tertiary] button:hover:not(:disabled) {\n  background-color: #f3fcff;\n}\n", ""]);

// exports


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UButtonGroupComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_button_group_component__ = __webpack_require__(53);



var UButtonGroupComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-button-group', []).component('uButtonGroup', __WEBPACK_IMPORTED_MODULE_1__u_button_group_component__["a" /* UButtonGroupComponent */]);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UButtonGroupComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_button_group_html__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_button_group_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_button_group_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_button_group_global_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_button_group_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__u_button_group_global_css__);



var UButtonGroupComponent = {
  transclude: true,
  template: __WEBPACK_IMPORTED_MODULE_0__u_button_group_html___default.a
};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "<ng-transclude></ng-transclude>\n"

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(56);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-button-group.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-button-group.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/* Breakpoint values taken from our original bootstrap setup:\n  xs: 480px\n  sm: 768px\n  md: 992px\n  lg: 1200px\n*/\n\n/*\n  Used to declare these as variables, but no longer works:\n  https://github.com/MoOx/postcss-cssnext/issues/262;\n*/\n\nu-button-group {\n  display: block;\n}\n\nu-button-group > ng-transclude {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%\n}\n\n@media (max-width: 767px) {\n\n  u-button-group > ng-transclude {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse;\n  }\n    }\n\n@media (min-width: 768px) {\n\n  u-button-group > ng-transclude {\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n  }/* If only one button, center it. */\n\n  u-button-group > ng-transclude > *:only-child {\n    margin: 0 auto;\n  }\n    }\n", ""]);

// exports


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UChecklistComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_checklist_component__ = __webpack_require__(58);



var UChecklistComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-checklist', []).component('uChecklist', __WEBPACK_IMPORTED_MODULE_1__u_checklist_component__["a" /* UChecklistComponent */]);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UChecklistComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_checklist_html__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_checklist_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_checklist_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_checklist_global_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_checklist_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__u_checklist_global_css__);



var UChecklistComponent = {
  bindings: {
    items: '<'
  },
  template: __WEBPACK_IMPORTED_MODULE_0__u_checklist_html___default.a
};

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "<ul>\n  <li ng-repeat=\"item in ::$ctrl.items\">{{::item}}</li>\n</ul>\n"

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(61);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-checklist.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-checklist.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/* Breakpoint values taken from our original bootstrap setup:\n  xs: 480px\n  sm: 768px\n  md: 992px\n  lg: 1200px\n*/\n\n/*\n  Used to declare these as variables, but no longer works:\n  https://github.com/MoOx/postcss-cssnext/issues/262;\n*/\n\nu-checklist ul {\n\n    padding-left: 40px;\n\n    list-style: none;\n}\n\nu-checklist li::before {\n\n    font-family: 'FontAwesome';\n\n    margin: 0 8px 0 -25px;\n\n    content: '\\F00C';\n\n    color: #75c79b;\n}\n\n@media (max-width: 767px) {\n\n    u-checklist {\n\n        font-size: 14px;\n    }\n  }\n", ""]);

// exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UCtaCardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_button__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_cta_card_component__ = __webpack_require__(63);




var UCtaCardComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-cta-card', [__WEBPACK_IMPORTED_MODULE_1__u_button__["a" /* UButtonComponent */].name]).component('uCtaCard', __WEBPACK_IMPORTED_MODULE_2__u_cta_card_component__["a" /* UCtaCardComponent */]);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UCtaCardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_cta_card_html__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_cta_card_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_cta_card_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_cta_card_global_css__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_cta_card_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__u_cta_card_global_css__);



var UCtaCardComponent = {
  bindings: {
    ctaText: '@',
    ctaUrl: '@',
    analytics: '<'
  },
  transclude: true,
  template: __WEBPACK_IMPORTED_MODULE_0__u_cta_card_html___default.a
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "<ng-transclude></ng-transclude>\n\n<u-button\n  ng-href=\"{{::$ctrl.ctaUrl}}\"\n  analytics-on\n  analytics-if=\"{{!!$ctrl.analytics}}\"\n  analytics-event=\"{{::$ctrl.analytics.eventName}}\"\n  analytics-properties=\"{{::$ctrl.analytics.properties}}\"\n>\n  {{::$ctrl.ctaText}}\n</u-button>\n"

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(66);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-cta-card.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-cta-card.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/* Breakpoint values taken from our original bootstrap setup:\n  xs: 480px\n  sm: 768px\n  md: 992px\n  lg: 1200px\n*/\n\n/*\n  Used to declare these as variables, but no longer works:\n  https://github.com/MoOx/postcss-cssnext/issues/262;\n*/\n\nu-cta-card {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 30px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e4e4e5;\n}\n\nu-cta-card > ng-transclude {\n  display: block;\n  margin-bottom: 20px;/* Need to expiclity set flex basis value for IE 11 */\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n}\n\n@media (max-width: 767px) {\n\n  u-cta-card {\n    padding: 20px 10px;\n  }\n  }\n\nu-cta-card[secondary] {\n  background-color: #efefef;\n}\n", ""]);

// exports


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UErrorPageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_ui_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_error_page_component__ = __webpack_require__(68);




var UErrorPageComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('u-error-page', [__WEBPACK_IMPORTED_MODULE_1_angular_ui_router___default.a]).component('uErrorPage', __WEBPACK_IMPORTED_MODULE_2__u_error_page_component__["a" /* UErrorPageComponent */]);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UErrorPageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_error_page_html__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_error_page_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_error_page_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_error_page_global_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_error_page_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__u_error_page_global_css__);



var UErrorPageComponent = {
  template: __WEBPACK_IMPORTED_MODULE_0__u_error_page_html___default.a,
  bindings: {
    onClick: '&onButtonClick'
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-ErrorPage\">\n  <header>\n    <span class=\"ico-medium ico-maintenance\"></span>\n\n    <h3 class=\"text-danger\">\n      Bear with us while we update... er... Updater.\n    </h3>\n\n    <button class=\"btn btn-primary\" ng-click=\"$ctrl.onClick()\">\n      Get me outta here!\n    </button>\n  </header>\n\n  <section class=\"u-ErrorPage-suggestionHeader main-section-leading\">\n    <header>\n      It's only going to be a few minutes, so here are<br class=\"hidden-xs\"/> a few things you can do in the meantime:\n    </header>\n  </section>\n\n  <section class=\"u-ErrorPage-suggestions\">\n    <div class=\"u-ErrorPage-suggestion\">\n      <span class=\"ico-accounts ico-small\"></span>\n      <p class=\"tiny text-muted mg-vertical-medium\">\n        Gather all of your magazines and subscriptions that need your new address\n      </p>\n    </div>\n\n    <div class=\"u-ErrorPage-suggestion\">\n      <span class=\"ico-dmv ico-small\"></span>\n      <p class=\"tiny text-muted mg-vertical-medium\">\n        Think about whether or not you need to change your address with the DMV. We can help\n      </p>\n    </div>\n\n    <div class=\"u-ErrorPage-suggestion\">\n      <span class=\"ico-list ico-small\"></span>\n      <p class=\"tiny text-muted mg-vertical-medium\">\n        Make a list of your friends who you want to receive your digital moving announcement\n      </p>\n    </div>\n\n    <div class=\"u-ErrorPage-suggestion\">\n      <span class=\"ico-sandwich ico-small\"></span>\n      <p class=\"tiny text-muted mg-vertical-medium\">\n        Make yourself a sandwich\n      </p>\n    </div>\n  </section>\n\n  <footer>\n    <a ui-sref=\"app\" class=\"u-ErrorPage-logoLink\"></a>\n  </footer>\n</div>\n"

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(71);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-error-page.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-error-page.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".u-ErrorPage {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.u-ErrorPage > header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 25px;\n  text-align: center;\n}\n.u-ErrorPage > footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  border-top: 1px solid #dddddd;\n  width: 100%;\n}\n.u-ErrorPage-suggestionHeader {\n  width: 100%;\n  text-align: center;\n  margin: 0 10px;\n}\n.u-ErrorPage-suggestions {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin: 20px 0;\n  /* Needed for IE11 */\n  width: 100%;\n}\n.u-ErrorPage-suggestion {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 185px;\n  margin: 10px;\n  text-align: center;\n}\n/* Needed for IE11 */\n.u-ErrorPage-suggestion > p {\n  width: 100%;\n}\n.u-ErrorPage-logoLink:before {\n  content: '';\n  display: inline-block;\n  background: url('//d30c45h9cuv4p4.cloudfront.net/updater-logo.svg') no-repeat center center;\n  width: 109px;\n  height: 50px;\n  margin: 20px 0 10px;\n}\n", ""]);

// exports


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UFaIconComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_fa_icon_html__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_fa_icon_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_fa_icon_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_fa_icon_global_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_fa_icon_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__u_fa_icon_global_css__);



var UFaIconComponent = {
  bindings: {
    name: '@'
  },
  template: __WEBPACK_IMPORTED_MODULE_0__u_fa_icon_html___default.a
};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "<span ng-class=\"'fa fa-' + $ctrl.name\"></span>\n"

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(75);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-fa-icon.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-fa-icon.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "u-fa-icon {\n  /*!\n *  Font Awesome 4.1.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n  /* FONT PATH\n * -------------------------- */\n  @font-face {\n\n    font-family: 'FontAwesome';\n\n    src: url('$cdnFonts/fontawesome-webfont.eot');\n\n    src: url('$cdnFonts/fontawesome-webfont.eot?#iefix')\n      format('embedded-opentype'),\n    url('$cdnFonts/fontawesome-webfont.woff') format('woff'),\n    url('$cdnFonts/fontawesome-webfont.ttf') format('truetype'),\n    url('$cdnFonts/fontawesome-webfont.svg?#fontawesomeregular') format('svg');\n\n    font-weight: normal;\n\n    font-style: normal;\n  }\n  @-webkit-keyframes spin {\n    0% {\n\n      -webkit-transform: rotate(0deg);\n    }\n    100% {\n\n      -webkit-transform: rotate(359deg);\n    }\n  }\n  @keyframes spin {\n    0% {\n\n      -webkit-transform: rotate(0deg);\n\n      transform: rotate(0deg);\n    }\n    100% {\n\n      -webkit-transform: rotate(359deg);\n\n      transform: rotate(359deg);\n    }\n  }\n\n  display: inline-block;\n}\nu-fa-icon {\n\n  ,: \"//d30c45h9cuv4p4.cloudfront.net/fonts\";\n}\nu-fa-icon .fa {\n\n  display: inline-block;\n\n  font-family: FontAwesome;\n\n  font-style: normal;\n\n  font-weight: normal;\n\n  line-height: 1;\n\n  -webkit-font-smoothing: antialiased;\n\n  -moz-osx-font-smoothing: grayscale;\n}\n/* makes the font 33% larger relative to the icon container */\nu-fa-icon .fa-lg {\n\n  font-size: 1.33333333em;\n\n  line-height: 0.75em;\n\n  vertical-align: -15%;\n}\nu-fa-icon .fa-2x {\n\n  font-size: 2em;\n}\nu-fa-icon .fa-3x {\n\n  font-size: 3em;\n}\nu-fa-icon .fa-4x {\n\n  font-size: 4em;\n}\nu-fa-icon .fa-5x {\n\n  font-size: 5em;\n}\nu-fa-icon .fa-fw {\n\n  width: 1.28571429em;\n\n  text-align: center;\n}\nu-fa-icon .fa-ul {\n\n  padding-left: 0;\n\n  margin-left: 2.14285714em;\n\n  list-style-type: none;\n}\nu-fa-icon .fa-ul > li {\n\n  position: relative;\n}\nu-fa-icon .fa-li {\n\n  position: absolute;\n\n  left: -2.14285714em;\n\n  width: 2.14285714em;\n\n  top: 0.14285714em;\n\n  text-align: center;\n}\nu-fa-icon .fa-li.fa-lg {\n\n  left: -1.85714286em;\n}\nu-fa-icon .fa-border {\n\n  padding: 0.2em 0.25em 0.15em;\n\n  border: solid 0.08em #eeeeee;\n\n  border-radius: 0.1em;\n}\nu-fa-icon .pull-right {\n\n  float: right;\n}\nu-fa-icon .pull-left {\n\n  float: left;\n}\nu-fa-icon .fa.pull-left {\n\n  margin-right: 0.3em;\n}\nu-fa-icon .fa.pull-right {\n\n  margin-left: 0.3em;\n}\nu-fa-icon .fa-spin {\n\n  -webkit-animation: spin 2s infinite linear;\n\n  animation: spin 2s infinite linear;\n}\nu-fa-icon .fa-rotate-90 {\n\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n\n  -webkit-transform: rotate(90deg);\n\n  transform: rotate(90deg);\n}\nu-fa-icon .fa-rotate-180 {\n\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n\n  -webkit-transform: rotate(180deg);\n\n  transform: rotate(180deg);\n}\nu-fa-icon .fa-rotate-270 {\n\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n\n  -webkit-transform: rotate(270deg);\n\n  transform: rotate(270deg);\n}\nu-fa-icon .fa-flip-horizontal {\n\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n\n  -webkit-transform: scale(-1, 1);\n\n  transform: scale(-1, 1);\n}\nu-fa-icon .fa-flip-vertical {\n\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n\n  -webkit-transform: scale(1, -1);\n\n  transform: scale(1, -1);\n}\nu-fa-icon .fa-stack {\n\n  position: relative;\n\n  display: inline-block;\n\n  width: 2em;\n\n  height: 2em;\n\n  line-height: 2em;\n\n  vertical-align: middle;\n}\nu-fa-icon .fa-stack-1x, u-fa-icon .fa-stack-2x {\n\n  position: absolute;\n\n  left: 0;\n\n  width: 100%;\n\n  text-align: center;\n}\nu-fa-icon .fa-stack-1x {\n\n  line-height: inherit;\n}\nu-fa-icon .fa-stack-2x {\n\n  font-size: 2em;\n}\nu-fa-icon .fa-inverse {\n\n  color: #ffffff;\n}\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\nu-fa-icon .fa-glass:before {\n\n  content: '\\F000';\n}\nu-fa-icon .fa-music:before {\n\n  content: '\\F001';\n}\nu-fa-icon .fa-search:before {\n\n  content: '\\F002';\n}\nu-fa-icon .fa-envelope-o:before {\n\n  content: '\\F003';\n}\nu-fa-icon .fa-heart:before {\n\n  content: '\\F004';\n}\nu-fa-icon .fa-star:before {\n\n  content: '\\F005';\n}\nu-fa-icon .fa-star-o:before {\n\n  content: '\\F006';\n}\nu-fa-icon .fa-user:before {\n\n  content: '\\F007';\n}\nu-fa-icon .fa-film:before {\n\n  content: '\\F008';\n}\nu-fa-icon .fa-th-large:before {\n\n  content: '\\F009';\n}\nu-fa-icon .fa-th:before {\n\n  content: '\\F00A';\n}\nu-fa-icon .fa-th-list:before {\n\n  content: '\\F00B';\n}\nu-fa-icon .fa-check:before {\n\n  content: '\\F00C';\n}\nu-fa-icon .fa-times:before {\n\n  content: '\\F00D';\n}\nu-fa-icon .fa-search-plus:before {\n\n  content: '\\F00E';\n}\nu-fa-icon .fa-search-minus:before {\n\n  content: '\\F010';\n}\nu-fa-icon .fa-power-off:before {\n\n  content: '\\F011';\n}\nu-fa-icon .fa-signal:before {\n\n  content: '\\F012';\n}\nu-fa-icon .fa-gear:before, u-fa-icon .fa-cog:before {\n\n  content: '\\F013';\n}\nu-fa-icon .fa-trash-o:before {\n\n  content: '\\F014';\n}\nu-fa-icon .fa-home:before {\n\n  content: '\\F015';\n}\nu-fa-icon .fa-file-o:before {\n\n  content: '\\F016';\n}\nu-fa-icon .fa-clock-o:before {\n\n  content: '\\F017';\n}\nu-fa-icon .fa-road:before {\n\n  content: '\\F018';\n}\nu-fa-icon .fa-download:before {\n\n  content: '\\F019';\n}\nu-fa-icon .fa-arrow-circle-o-down:before {\n\n  content: '\\F01A';\n}\nu-fa-icon .fa-arrow-circle-o-up:before {\n\n  content: '\\F01B';\n}\nu-fa-icon .fa-inbox:before {\n\n  content: '\\F01C';\n}\nu-fa-icon .fa-play-circle-o:before {\n\n  content: '\\F01D';\n}\nu-fa-icon .fa-rotate-right:before, u-fa-icon .fa-repeat:before {\n\n  content: '\\F01E';\n}\nu-fa-icon .fa-refresh:before {\n\n  content: '\\F021';\n}\nu-fa-icon .fa-list-alt:before {\n\n  content: '\\F022';\n}\nu-fa-icon .fa-lock:before {\n\n  content: '\\F023';\n}\nu-fa-icon .fa-flag:before {\n\n  content: '\\F024';\n}\nu-fa-icon .fa-headphones:before {\n\n  content: '\\F025';\n}\nu-fa-icon .fa-volume-off:before {\n\n  content: '\\F026';\n}\nu-fa-icon .fa-volume-down:before {\n\n  content: '\\F027';\n}\nu-fa-icon .fa-volume-up:before {\n\n  content: '\\F028';\n}\nu-fa-icon .fa-qrcode:before {\n\n  content: '\\F029';\n}\nu-fa-icon .fa-barcode:before {\n\n  content: '\\F02A';\n}\nu-fa-icon .fa-tag:before {\n\n  content: '\\F02B';\n}\nu-fa-icon .fa-tags:before {\n\n  content: '\\F02C';\n}\nu-fa-icon .fa-book:before {\n\n  content: '\\F02D';\n}\nu-fa-icon .fa-bookmark:before {\n\n  content: '\\F02E';\n}\nu-fa-icon .fa-print:before {\n\n  content: '\\F02F';\n}\nu-fa-icon .fa-camera:before {\n\n  content: '\\F030';\n}\nu-fa-icon .fa-font:before {\n\n  content: '\\F031';\n}\nu-fa-icon .fa-bold:before {\n\n  content: '\\F032';\n}\nu-fa-icon .fa-italic:before {\n\n  content: '\\F033';\n}\nu-fa-icon .fa-text-height:before {\n\n  content: '\\F034';\n}\nu-fa-icon .fa-text-width:before {\n\n  content: '\\F035';\n}\nu-fa-icon .fa-align-left:before {\n\n  content: '\\F036';\n}\nu-fa-icon .fa-align-center:before {\n\n  content: '\\F037';\n}\nu-fa-icon .fa-align-right:before {\n\n  content: '\\F038';\n}\nu-fa-icon .fa-align-justify:before {\n\n  content: '\\F039';\n}\nu-fa-icon .fa-list:before {\n\n  content: '\\F03A';\n}\nu-fa-icon .fa-dedent:before, u-fa-icon .fa-outdent:before {\n\n  content: '\\F03B';\n}\nu-fa-icon .fa-indent:before {\n\n  content: '\\F03C';\n}\nu-fa-icon .fa-video-camera:before {\n\n  content: '\\F03D';\n}\nu-fa-icon .fa-photo:before, u-fa-icon .fa-image:before, u-fa-icon .fa-picture-o:before {\n\n  content: '\\F03E';\n}\nu-fa-icon .fa-pencil:before {\n\n  content: '\\F040';\n}\nu-fa-icon .fa-map-marker:before {\n\n  content: '\\F041';\n}\nu-fa-icon .fa-adjust:before {\n\n  content: '\\F042';\n}\nu-fa-icon .fa-tint:before {\n\n  content: '\\F043';\n}\nu-fa-icon .fa-edit:before, u-fa-icon .fa-pencil-square-o:before {\n\n  content: '\\F044';\n}\nu-fa-icon .fa-share-square-o:before {\n\n  content: '\\F045';\n}\nu-fa-icon .fa-check-square-o:before {\n\n  content: '\\F046';\n}\nu-fa-icon .fa-arrows:before {\n\n  content: '\\F047';\n}\nu-fa-icon .fa-step-backward:before {\n\n  content: '\\F048';\n}\nu-fa-icon .fa-fast-backward:before {\n\n  content: '\\F049';\n}\nu-fa-icon .fa-backward:before {\n\n  content: '\\F04A';\n}\nu-fa-icon .fa-play:before {\n\n  content: '\\F04B';\n}\nu-fa-icon .fa-pause:before {\n\n  content: '\\F04C';\n}\nu-fa-icon .fa-stop:before {\n\n  content: '\\F04D';\n}\nu-fa-icon .fa-forward:before {\n\n  content: '\\F04E';\n}\nu-fa-icon .fa-fast-forward:before {\n\n  content: '\\F050';\n}\nu-fa-icon .fa-step-forward:before {\n\n  content: '\\F051';\n}\nu-fa-icon .fa-eject:before {\n\n  content: '\\F052';\n}\nu-fa-icon .fa-chevron-left:before {\n\n  content: '\\F053';\n}\nu-fa-icon .fa-chevron-right:before {\n\n  content: '\\F054';\n}\nu-fa-icon .fa-plus-circle:before {\n\n  content: '\\F055';\n}\nu-fa-icon .fa-minus-circle:before {\n\n  content: '\\F056';\n}\nu-fa-icon .fa-times-circle:before {\n\n  content: '\\F057';\n}\nu-fa-icon .fa-check-circle:before {\n\n  content: '\\F058';\n}\nu-fa-icon .fa-question-circle:before {\n\n  content: '\\F059';\n}\nu-fa-icon .fa-info-circle:before {\n\n  content: '\\F05A';\n}\nu-fa-icon .fa-crosshairs:before {\n\n  content: '\\F05B';\n}\nu-fa-icon .fa-times-circle-o:before {\n\n  content: '\\F05C';\n}\nu-fa-icon .fa-check-circle-o:before {\n\n  content: '\\F05D';\n}\nu-fa-icon .fa-ban:before {\n\n  content: '\\F05E';\n}\nu-fa-icon .fa-arrow-left:before {\n\n  content: '\\F060';\n}\nu-fa-icon .fa-arrow-right:before {\n\n  content: '\\F061';\n}\nu-fa-icon .fa-arrow-up:before {\n\n  content: '\\F062';\n}\nu-fa-icon .fa-arrow-down:before {\n\n  content: '\\F063';\n}\nu-fa-icon .fa-mail-forward:before, u-fa-icon .fa-share:before {\n\n  content: '\\F064';\n}\nu-fa-icon .fa-expand:before {\n\n  content: '\\F065';\n}\nu-fa-icon .fa-compress:before {\n\n  content: '\\F066';\n}\nu-fa-icon .fa-plus:before {\n\n  content: '\\F067';\n}\nu-fa-icon .fa-minus:before {\n\n  content: '\\F068';\n}\nu-fa-icon .fa-asterisk:before {\n\n  content: '\\F069';\n}\nu-fa-icon .fa-exclamation-circle:before {\n\n  content: '\\F06A';\n}\nu-fa-icon .fa-gift:before {\n\n  content: '\\F06B';\n}\nu-fa-icon .fa-leaf:before {\n\n  content: '\\F06C';\n}\nu-fa-icon .fa-fire:before {\n\n  content: '\\F06D';\n}\nu-fa-icon .fa-eye:before {\n\n  content: '\\F06E';\n}\nu-fa-icon .fa-eye-slash:before {\n\n  content: '\\F070';\n}\nu-fa-icon .fa-warning:before, u-fa-icon .fa-exclamation-triangle:before {\n\n  content: '\\F071';\n}\nu-fa-icon .fa-plane:before {\n\n  content: '\\F072';\n}\nu-fa-icon .fa-calendar:before {\n\n  content: '\\F073';\n}\nu-fa-icon .fa-random:before {\n\n  content: '\\F074';\n}\nu-fa-icon .fa-comment:before {\n\n  content: '\\F075';\n}\nu-fa-icon .fa-magnet:before {\n\n  content: '\\F076';\n}\nu-fa-icon .fa-chevron-up:before {\n\n  content: '\\F077';\n}\nu-fa-icon .fa-chevron-down:before {\n\n  content: '\\F078';\n}\nu-fa-icon .fa-retweet:before {\n\n  content: '\\F079';\n}\nu-fa-icon .fa-shopping-cart:before {\n\n  content: '\\F07A';\n}\nu-fa-icon .fa-folder:before {\n\n  content: '\\F07B';\n}\nu-fa-icon .fa-folder-open:before {\n\n  content: '\\F07C';\n}\nu-fa-icon .fa-arrows-v:before {\n\n  content: '\\F07D';\n}\nu-fa-icon .fa-arrows-h:before {\n\n  content: '\\F07E';\n}\nu-fa-icon .fa-bar-chart-o:before {\n\n  content: '\\F080';\n}\nu-fa-icon .fa-twitter-square:before {\n\n  content: '\\F081';\n}\nu-fa-icon .fa-facebook-square:before {\n\n  content: '\\F082';\n}\nu-fa-icon .fa-camera-retro:before {\n\n  content: '\\F083';\n}\nu-fa-icon .fa-key:before {\n\n  content: '\\F084';\n}\nu-fa-icon .fa-gears:before, u-fa-icon .fa-cogs:before {\n\n  content: '\\F085';\n}\nu-fa-icon .fa-comments:before {\n\n  content: '\\F086';\n}\nu-fa-icon .fa-thumbs-o-up:before {\n\n  content: '\\F087';\n}\nu-fa-icon .fa-thumbs-o-down:before {\n\n  content: '\\F088';\n}\nu-fa-icon .fa-star-half:before {\n\n  content: '\\F089';\n}\nu-fa-icon .fa-heart-o:before {\n\n  content: '\\F08A';\n}\nu-fa-icon .fa-sign-out:before {\n\n  content: '\\F08B';\n}\nu-fa-icon .fa-linkedin-square:before {\n\n  content: '\\F08C';\n}\nu-fa-icon .fa-thumb-tack:before {\n\n  content: '\\F08D';\n}\nu-fa-icon .fa-external-link:before {\n\n  content: '\\F08E';\n}\nu-fa-icon .fa-sign-in:before {\n\n  content: '\\F090';\n}\nu-fa-icon .fa-trophy:before {\n\n  content: '\\F091';\n}\nu-fa-icon .fa-github-square:before {\n\n  content: '\\F092';\n}\nu-fa-icon .fa-upload:before {\n\n  content: '\\F093';\n}\nu-fa-icon .fa-lemon-o:before {\n\n  content: '\\F094';\n}\nu-fa-icon .fa-phone:before {\n\n  content: '\\F095';\n}\nu-fa-icon .fa-square-o:before {\n\n  content: '\\F096';\n}\nu-fa-icon .fa-bookmark-o:before {\n\n  content: '\\F097';\n}\nu-fa-icon .fa-phone-square:before {\n\n  content: '\\F098';\n}\nu-fa-icon .fa-twitter:before {\n\n  content: '\\F099';\n}\nu-fa-icon .fa-facebook:before {\n\n  content: '\\F09A';\n}\nu-fa-icon .fa-github:before {\n\n  content: '\\F09B';\n}\nu-fa-icon .fa-unlock:before {\n\n  content: '\\F09C';\n}\nu-fa-icon .fa-credit-card:before {\n\n  content: '\\F09D';\n}\nu-fa-icon .fa-rss:before {\n\n  content: '\\F09E';\n}\nu-fa-icon .fa-hdd-o:before {\n\n  content: '\\F0A0';\n}\nu-fa-icon .fa-bullhorn:before {\n\n  content: '\\F0A1';\n}\nu-fa-icon .fa-bell:before {\n\n  content: '\\F0F3';\n}\nu-fa-icon .fa-certificate:before {\n\n  content: '\\F0A3';\n}\nu-fa-icon .fa-hand-o-right:before {\n\n  content: '\\F0A4';\n}\nu-fa-icon .fa-hand-o-left:before {\n\n  content: '\\F0A5';\n}\nu-fa-icon .fa-hand-o-up:before {\n\n  content: '\\F0A6';\n}\nu-fa-icon .fa-hand-o-down:before {\n\n  content: '\\F0A7';\n}\nu-fa-icon .fa-arrow-circle-left:before {\n\n  content: '\\F0A8';\n}\nu-fa-icon .fa-arrow-circle-right:before {\n\n  content: '\\F0A9';\n}\nu-fa-icon .fa-arrow-circle-up:before {\n\n  content: '\\F0AA';\n}\nu-fa-icon .fa-arrow-circle-down:before {\n\n  content: '\\F0AB';\n}\nu-fa-icon .fa-globe:before {\n\n  content: '\\F0AC';\n}\nu-fa-icon .fa-wrench:before {\n\n  content: '\\F0AD';\n}\nu-fa-icon .fa-tasks:before {\n\n  content: '\\F0AE';\n}\nu-fa-icon .fa-filter:before {\n\n  content: '\\F0B0';\n}\nu-fa-icon .fa-briefcase:before {\n\n  content: '\\F0B1';\n}\nu-fa-icon .fa-arrows-alt:before {\n\n  content: '\\F0B2';\n}\nu-fa-icon .fa-group:before, u-fa-icon .fa-users:before {\n\n  content: '\\F0C0';\n}\nu-fa-icon .fa-chain:before, u-fa-icon .fa-link:before {\n\n  content: '\\F0C1';\n}\nu-fa-icon .fa-cloud:before {\n\n  content: '\\F0C2';\n}\nu-fa-icon .fa-flask:before {\n\n  content: '\\F0C3';\n}\nu-fa-icon .fa-cut:before, u-fa-icon .fa-scissors:before {\n\n  content: '\\F0C4';\n}\nu-fa-icon .fa-copy:before, u-fa-icon .fa-files-o:before {\n\n  content: '\\F0C5';\n}\nu-fa-icon .fa-paperclip:before {\n\n  content: '\\F0C6';\n}\nu-fa-icon .fa-save:before, u-fa-icon .fa-floppy-o:before {\n\n  content: '\\F0C7';\n}\nu-fa-icon .fa-square:before {\n\n  content: '\\F0C8';\n}\nu-fa-icon .fa-navicon:before, u-fa-icon .fa-reorder:before, u-fa-icon .fa-bars:before {\n\n  content: '\\F0C9';\n}\nu-fa-icon .fa-list-ul:before {\n\n  content: '\\F0CA';\n}\nu-fa-icon .fa-list-ol:before {\n\n  content: '\\F0CB';\n}\nu-fa-icon .fa-strikethrough:before {\n\n  content: '\\F0CC';\n}\nu-fa-icon .fa-underline:before {\n\n  content: '\\F0CD';\n}\nu-fa-icon .fa-table:before {\n\n  content: '\\F0CE';\n}\nu-fa-icon .fa-magic:before {\n\n  content: '\\F0D0';\n}\nu-fa-icon .fa-truck:before {\n\n  content: '\\F0D1';\n}\nu-fa-icon .fa-pinterest:before {\n\n  content: '\\F0D2';\n}\nu-fa-icon .fa-pinterest-square:before {\n\n  content: '\\F0D3';\n}\nu-fa-icon .fa-google-plus-square:before {\n\n  content: '\\F0D4';\n}\nu-fa-icon .fa-google-plus:before {\n\n  content: '\\F0D5';\n}\nu-fa-icon .fa-money:before {\n\n  content: '\\F0D6';\n}\nu-fa-icon .fa-caret-down:before {\n\n  content: '\\F0D7';\n}\nu-fa-icon .fa-caret-up:before {\n\n  content: '\\F0D8';\n}\nu-fa-icon .fa-caret-left:before {\n\n  content: '\\F0D9';\n}\nu-fa-icon .fa-caret-right:before {\n\n  content: '\\F0DA';\n}\nu-fa-icon .fa-columns:before {\n\n  content: '\\F0DB';\n}\nu-fa-icon .fa-unsorted:before, u-fa-icon .fa-sort:before {\n\n  content: '\\F0DC';\n}\nu-fa-icon .fa-sort-down:before, u-fa-icon .fa-sort-desc:before {\n\n  content: '\\F0DD';\n}\nu-fa-icon .fa-sort-up:before, u-fa-icon .fa-sort-asc:before {\n\n  content: '\\F0DE';\n}\nu-fa-icon .fa-envelope:before {\n\n  content: '\\F0E0';\n}\nu-fa-icon .fa-linkedin:before {\n\n  content: '\\F0E1';\n}\nu-fa-icon .fa-rotate-left:before, u-fa-icon .fa-undo:before {\n\n  content: '\\F0E2';\n}\nu-fa-icon .fa-legal:before, u-fa-icon .fa-gavel:before {\n\n  content: '\\F0E3';\n}\nu-fa-icon .fa-dashboard:before, u-fa-icon .fa-tachometer:before {\n\n  content: '\\F0E4';\n}\nu-fa-icon .fa-comment-o:before {\n\n  content: '\\F0E5';\n}\nu-fa-icon .fa-comments-o:before {\n\n  content: '\\F0E6';\n}\nu-fa-icon .fa-flash:before, u-fa-icon .fa-bolt:before {\n\n  content: '\\F0E7';\n}\nu-fa-icon .fa-sitemap:before {\n\n  content: '\\F0E8';\n}\nu-fa-icon .fa-umbrella:before {\n\n  content: '\\F0E9';\n}\nu-fa-icon .fa-paste:before, u-fa-icon .fa-clipboard:before {\n\n  content: '\\F0EA';\n}\nu-fa-icon .fa-lightbulb-o:before {\n\n  content: '\\F0EB';\n}\nu-fa-icon .fa-exchange:before {\n\n  content: '\\F0EC';\n}\nu-fa-icon .fa-cloud-download:before {\n\n  content: '\\F0ED';\n}\nu-fa-icon .fa-cloud-upload:before {\n\n  content: '\\F0EE';\n}\nu-fa-icon .fa-user-md:before {\n\n  content: '\\F0F0';\n}\nu-fa-icon .fa-stethoscope:before {\n\n  content: '\\F0F1';\n}\nu-fa-icon .fa-suitcase:before {\n\n  content: '\\F0F2';\n}\nu-fa-icon .fa-bell-o:before {\n\n  content: '\\F0A2';\n}\nu-fa-icon .fa-coffee:before {\n\n  content: '\\F0F4';\n}\nu-fa-icon .fa-cutlery:before {\n\n  content: '\\F0F5';\n}\nu-fa-icon .fa-file-text-o:before {\n\n  content: '\\F0F6';\n}\nu-fa-icon .fa-building-o:before {\n\n  content: '\\F0F7';\n}\nu-fa-icon .fa-hospital-o:before {\n\n  content: '\\F0F8';\n}\nu-fa-icon .fa-ambulance:before {\n\n  content: '\\F0F9';\n}\nu-fa-icon .fa-medkit:before {\n\n  content: '\\F0FA';\n}\nu-fa-icon .fa-fighter-jet:before {\n\n  content: '\\F0FB';\n}\nu-fa-icon .fa-beer:before {\n\n  content: '\\F0FC';\n}\nu-fa-icon .fa-h-square:before {\n\n  content: '\\F0FD';\n}\nu-fa-icon .fa-plus-square:before {\n\n  content: '\\F0FE';\n}\nu-fa-icon .fa-angle-double-left:before {\n\n  content: '\\F100';\n}\nu-fa-icon .fa-angle-double-right:before {\n\n  content: '\\F101';\n}\nu-fa-icon .fa-angle-double-up:before {\n\n  content: '\\F102';\n}\nu-fa-icon .fa-angle-double-down:before {\n\n  content: '\\F103';\n}\nu-fa-icon .fa-angle-left:before {\n\n  content: '\\F104';\n}\nu-fa-icon .fa-angle-right:before {\n\n  content: '\\F105';\n}\nu-fa-icon .fa-angle-up:before {\n\n  content: '\\F106';\n}\nu-fa-icon .fa-angle-down:before {\n\n  content: '\\F107';\n}\nu-fa-icon .fa-desktop:before {\n\n  content: '\\F108';\n}\nu-fa-icon .fa-laptop:before {\n\n  content: '\\F109';\n}\nu-fa-icon .fa-tablet:before {\n\n  content: '\\F10A';\n}\nu-fa-icon .fa-mobile-phone:before, u-fa-icon .fa-mobile:before {\n\n  content: '\\F10B';\n}\nu-fa-icon .fa-circle-o:before {\n\n  content: '\\F10C';\n}\nu-fa-icon .fa-quote-left:before {\n\n  content: '\\F10D';\n}\nu-fa-icon .fa-quote-right:before {\n\n  content: '\\F10E';\n}\nu-fa-icon .fa-spinner:before {\n\n  content: '\\F110';\n}\nu-fa-icon .fa-circle:before {\n\n  content: '\\F111';\n}\nu-fa-icon .fa-mail-reply:before, u-fa-icon .fa-reply:before {\n\n  content: '\\F112';\n}\nu-fa-icon .fa-github-alt:before {\n\n  content: '\\F113';\n}\nu-fa-icon .fa-folder-o:before {\n\n  content: '\\F114';\n}\nu-fa-icon .fa-folder-open-o:before {\n\n  content: '\\F115';\n}\nu-fa-icon .fa-smile-o:before {\n\n  content: '\\F118';\n}\nu-fa-icon .fa-frown-o:before {\n\n  content: '\\F119';\n}\nu-fa-icon .fa-meh-o:before {\n\n  content: '\\F11A';\n}\nu-fa-icon .fa-gamepad:before {\n\n  content: '\\F11B';\n}\nu-fa-icon .fa-keyboard-o:before {\n\n  content: '\\F11C';\n}\nu-fa-icon .fa-flag-o:before {\n\n  content: '\\F11D';\n}\nu-fa-icon .fa-flag-checkered:before {\n\n  content: '\\F11E';\n}\nu-fa-icon .fa-terminal:before {\n\n  content: '\\F120';\n}\nu-fa-icon .fa-code:before {\n\n  content: '\\F121';\n}\nu-fa-icon .fa-mail-reply-all:before, u-fa-icon .fa-reply-all:before {\n\n  content: '\\F122';\n}\nu-fa-icon .fa-star-half-empty:before, u-fa-icon .fa-star-half-full:before, u-fa-icon .fa-star-half-o:before {\n\n  content: '\\F123';\n}\nu-fa-icon .fa-location-arrow:before {\n\n  content: '\\F124';\n}\nu-fa-icon .fa-crop:before {\n\n  content: '\\F125';\n}\nu-fa-icon .fa-code-fork:before {\n\n  content: '\\F126';\n}\nu-fa-icon .fa-unlink:before, u-fa-icon .fa-chain-broken:before {\n\n  content: '\\F127';\n}\nu-fa-icon .fa-question:before {\n\n  content: '\\F128';\n}\nu-fa-icon .fa-info:before {\n\n  content: '\\F129';\n}\nu-fa-icon .fa-exclamation:before {\n\n  content: '\\F12A';\n}\nu-fa-icon .fa-superscript:before {\n\n  content: '\\F12B';\n}\nu-fa-icon .fa-subscript:before {\n\n  content: '\\F12C';\n}\nu-fa-icon .fa-eraser:before {\n\n  content: '\\F12D';\n}\nu-fa-icon .fa-puzzle-piece:before {\n\n  content: '\\F12E';\n}\nu-fa-icon .fa-microphone:before {\n\n  content: '\\F130';\n}\nu-fa-icon .fa-microphone-slash:before {\n\n  content: '\\F131';\n}\nu-fa-icon .fa-shield:before {\n\n  content: '\\F132';\n}\nu-fa-icon .fa-calendar-o:before {\n\n  content: '\\F133';\n}\nu-fa-icon .fa-fire-extinguisher:before {\n\n  content: '\\F134';\n}\nu-fa-icon .fa-rocket:before {\n\n  content: '\\F135';\n}\nu-fa-icon .fa-maxcdn:before {\n\n  content: '\\F136';\n}\nu-fa-icon .fa-chevron-circle-left:before {\n\n  content: '\\F137';\n}\nu-fa-icon .fa-chevron-circle-right:before {\n\n  content: '\\F138';\n}\nu-fa-icon .fa-chevron-circle-up:before {\n\n  content: '\\F139';\n}\nu-fa-icon .fa-chevron-circle-down:before {\n\n  content: '\\F13A';\n}\nu-fa-icon .fa-html5:before {\n\n  content: '\\F13B';\n}\nu-fa-icon .fa-css3:before {\n\n  content: '\\F13C';\n}\nu-fa-icon .fa-anchor:before {\n\n  content: '\\F13D';\n}\nu-fa-icon .fa-unlock-alt:before {\n\n  content: '\\F13E';\n}\nu-fa-icon .fa-bullseye:before {\n\n  content: '\\F140';\n}\nu-fa-icon .fa-ellipsis-h:before {\n\n  content: '\\F141';\n}\nu-fa-icon .fa-ellipsis-v:before {\n\n  content: '\\F142';\n}\nu-fa-icon .fa-rss-square:before {\n\n  content: '\\F143';\n}\nu-fa-icon .fa-play-circle:before {\n\n  content: '\\F144';\n}\nu-fa-icon .fa-ticket:before {\n\n  content: '\\F145';\n}\nu-fa-icon .fa-minus-square:before {\n\n  content: '\\F146';\n}\nu-fa-icon .fa-minus-square-o:before {\n\n  content: '\\F147';\n}\nu-fa-icon .fa-level-up:before {\n\n  content: '\\F148';\n}\nu-fa-icon .fa-level-down:before {\n\n  content: '\\F149';\n}\nu-fa-icon .fa-check-square:before {\n\n  content: '\\F14A';\n}\nu-fa-icon .fa-pencil-square:before {\n\n  content: '\\F14B';\n}\nu-fa-icon .fa-external-link-square:before {\n\n  content: '\\F14C';\n}\nu-fa-icon .fa-share-square:before {\n\n  content: '\\F14D';\n}\nu-fa-icon .fa-compass:before {\n\n  content: '\\F14E';\n}\nu-fa-icon .fa-toggle-down:before, u-fa-icon .fa-caret-square-o-down:before {\n\n  content: '\\F150';\n}\nu-fa-icon .fa-toggle-up:before, u-fa-icon .fa-caret-square-o-up:before {\n\n  content: '\\F151';\n}\nu-fa-icon .fa-toggle-right:before, u-fa-icon .fa-caret-square-o-right:before {\n\n  content: '\\F152';\n}\nu-fa-icon .fa-euro:before, u-fa-icon .fa-eur:before {\n\n  content: '\\F153';\n}\nu-fa-icon .fa-gbp:before {\n\n  content: '\\F154';\n}\nu-fa-icon .fa-dollar:before, u-fa-icon .fa-usd:before {\n\n  content: '\\F155';\n}\nu-fa-icon .fa-rupee:before, u-fa-icon .fa-inr:before {\n\n  content: '\\F156';\n}\nu-fa-icon .fa-cny:before, u-fa-icon .fa-rmb:before, u-fa-icon .fa-yen:before, u-fa-icon .fa-jpy:before {\n\n  content: '\\F157';\n}\nu-fa-icon .fa-ruble:before, u-fa-icon .fa-rouble:before, u-fa-icon .fa-rub:before {\n\n  content: '\\F158';\n}\nu-fa-icon .fa-won:before, u-fa-icon .fa-krw:before {\n\n  content: '\\F159';\n}\nu-fa-icon .fa-bitcoin:before, u-fa-icon .fa-btc:before {\n\n  content: '\\F15A';\n}\nu-fa-icon .fa-file:before {\n\n  content: '\\F15B';\n}\nu-fa-icon .fa-file-text:before {\n\n  content: '\\F15C';\n}\nu-fa-icon .fa-sort-alpha-asc:before {\n\n  content: '\\F15D';\n}\nu-fa-icon .fa-sort-alpha-desc:before {\n\n  content: '\\F15E';\n}\nu-fa-icon .fa-sort-amount-asc:before {\n\n  content: '\\F160';\n}\nu-fa-icon .fa-sort-amount-desc:before {\n\n  content: '\\F161';\n}\nu-fa-icon .fa-sort-numeric-asc:before {\n\n  content: '\\F162';\n}\nu-fa-icon .fa-sort-numeric-desc:before {\n\n  content: '\\F163';\n}\nu-fa-icon .fa-thumbs-up:before {\n\n  content: '\\F164';\n}\nu-fa-icon .fa-thumbs-down:before {\n\n  content: '\\F165';\n}\nu-fa-icon .fa-youtube-square:before {\n\n  content: '\\F166';\n}\nu-fa-icon .fa-youtube:before {\n\n  content: '\\F167';\n}\nu-fa-icon .fa-xing:before {\n\n  content: '\\F168';\n}\nu-fa-icon .fa-xing-square:before {\n\n  content: '\\F169';\n}\nu-fa-icon .fa-youtube-play:before {\n\n  content: '\\F16A';\n}\nu-fa-icon .fa-dropbox:before {\n\n  content: '\\F16B';\n}\nu-fa-icon .fa-stack-overflow:before {\n\n  content: '\\F16C';\n}\nu-fa-icon .fa-instagram:before {\n\n  content: '\\F16D';\n}\nu-fa-icon .fa-flickr:before {\n\n  content: '\\F16E';\n}\nu-fa-icon .fa-adn:before {\n\n  content: '\\F170';\n}\nu-fa-icon .fa-bitbucket:before {\n\n  content: '\\F171';\n}\nu-fa-icon .fa-bitbucket-square:before {\n\n  content: '\\F172';\n}\nu-fa-icon .fa-tumblr:before {\n\n  content: '\\F173';\n}\nu-fa-icon .fa-tumblr-square:before {\n\n  content: '\\F174';\n}\nu-fa-icon .fa-long-arrow-down:before {\n\n  content: '\\F175';\n}\nu-fa-icon .fa-long-arrow-up:before {\n\n  content: '\\F176';\n}\nu-fa-icon .fa-long-arrow-left:before {\n\n  content: '\\F177';\n}\nu-fa-icon .fa-long-arrow-right:before {\n\n  content: '\\F178';\n}\nu-fa-icon .fa-apple:before {\n\n  content: '\\F179';\n}\nu-fa-icon .fa-windows:before {\n\n  content: '\\F17A';\n}\nu-fa-icon .fa-android:before {\n\n  content: '\\F17B';\n}\nu-fa-icon .fa-linux:before {\n\n  content: '\\F17C';\n}\nu-fa-icon .fa-dribbble:before {\n\n  content: '\\F17D';\n}\nu-fa-icon .fa-skype:before {\n\n  content: '\\F17E';\n}\nu-fa-icon .fa-foursquare:before {\n\n  content: '\\F180';\n}\nu-fa-icon .fa-trello:before {\n\n  content: '\\F181';\n}\nu-fa-icon .fa-female:before {\n\n  content: '\\F182';\n}\nu-fa-icon .fa-male:before {\n\n  content: '\\F183';\n}\nu-fa-icon .fa-gittip:before {\n\n  content: '\\F184';\n}\nu-fa-icon .fa-sun-o:before {\n\n  content: '\\F185';\n}\nu-fa-icon .fa-moon-o:before {\n\n  content: '\\F186';\n}\nu-fa-icon .fa-archive:before {\n\n  content: '\\F187';\n}\nu-fa-icon .fa-bug:before {\n\n  content: '\\F188';\n}\nu-fa-icon .fa-vk:before {\n\n  content: '\\F189';\n}\nu-fa-icon .fa-weibo:before {\n\n  content: '\\F18A';\n}\nu-fa-icon .fa-renren:before {\n\n  content: '\\F18B';\n}\nu-fa-icon .fa-pagelines:before {\n\n  content: '\\F18C';\n}\nu-fa-icon .fa-stack-exchange:before {\n\n  content: '\\F18D';\n}\nu-fa-icon .fa-arrow-circle-o-right:before {\n\n  content: '\\F18E';\n}\nu-fa-icon .fa-arrow-circle-o-left:before {\n\n  content: '\\F190';\n}\nu-fa-icon .fa-toggle-left:before, u-fa-icon .fa-caret-square-o-left:before {\n\n  content: '\\F191';\n}\nu-fa-icon .fa-dot-circle-o:before {\n\n  content: '\\F192';\n}\nu-fa-icon .fa-wheelchair:before {\n\n  content: '\\F193';\n}\nu-fa-icon .fa-vimeo-square:before {\n\n  content: '\\F194';\n}\nu-fa-icon .fa-turkish-lira:before, u-fa-icon .fa-try:before {\n\n  content: '\\F195';\n}\nu-fa-icon .fa-plus-square-o:before {\n\n  content: '\\F196';\n}\nu-fa-icon .fa-space-shuttle:before {\n\n  content: '\\F197';\n}\nu-fa-icon .fa-slack:before {\n\n  content: '\\F198';\n}\nu-fa-icon .fa-envelope-square:before {\n\n  content: '\\F199';\n}\nu-fa-icon .fa-wordpress:before {\n\n  content: '\\F19A';\n}\nu-fa-icon .fa-openid:before {\n\n  content: '\\F19B';\n}\nu-fa-icon .fa-institution:before, u-fa-icon .fa-bank:before, u-fa-icon .fa-university:before {\n\n  content: '\\F19C';\n}\nu-fa-icon .fa-mortar-board:before, u-fa-icon .fa-graduation-cap:before {\n\n  content: '\\F19D';\n}\nu-fa-icon .fa-yahoo:before {\n\n  content: '\\F19E';\n}\nu-fa-icon .fa-google:before {\n\n  content: '\\F1A0';\n}\nu-fa-icon .fa-reddit:before {\n\n  content: '\\F1A1';\n}\nu-fa-icon .fa-reddit-square:before {\n\n  content: '\\F1A2';\n}\nu-fa-icon .fa-stumbleupon-circle:before {\n\n  content: '\\F1A3';\n}\nu-fa-icon .fa-stumbleupon:before {\n\n  content: '\\F1A4';\n}\nu-fa-icon .fa-delicious:before {\n\n  content: '\\F1A5';\n}\nu-fa-icon .fa-digg:before {\n\n  content: '\\F1A6';\n}\nu-fa-icon .fa-pied-piper-square:before, u-fa-icon .fa-pied-piper:before {\n\n  content: '\\F1A7';\n}\nu-fa-icon .fa-pied-piper-alt:before {\n\n  content: '\\F1A8';\n}\nu-fa-icon .fa-drupal:before {\n\n  content: '\\F1A9';\n}\nu-fa-icon .fa-joomla:before {\n\n  content: '\\F1AA';\n}\nu-fa-icon .fa-language:before {\n\n  content: '\\F1AB';\n}\nu-fa-icon .fa-fax:before {\n\n  content: '\\F1AC';\n}\nu-fa-icon .fa-building:before {\n\n  content: '\\F1AD';\n}\nu-fa-icon .fa-child:before {\n\n  content: '\\F1AE';\n}\nu-fa-icon .fa-paw:before {\n\n  content: '\\F1B0';\n}\nu-fa-icon .fa-spoon:before {\n\n  content: '\\F1B1';\n}\nu-fa-icon .fa-cube:before {\n\n  content: '\\F1B2';\n}\nu-fa-icon .fa-cubes:before {\n\n  content: '\\F1B3';\n}\nu-fa-icon .fa-behance:before {\n\n  content: '\\F1B4';\n}\nu-fa-icon .fa-behance-square:before {\n\n  content: '\\F1B5';\n}\nu-fa-icon .fa-steam:before {\n\n  content: '\\F1B6';\n}\nu-fa-icon .fa-steam-square:before {\n\n  content: '\\F1B7';\n}\nu-fa-icon .fa-recycle:before {\n\n  content: '\\F1B8';\n}\nu-fa-icon .fa-automobile:before, u-fa-icon .fa-car:before {\n\n  content: '\\F1B9';\n}\nu-fa-icon .fa-cab:before, u-fa-icon .fa-taxi:before {\n\n  content: '\\F1BA';\n}\nu-fa-icon .fa-tree:before {\n\n  content: '\\F1BB';\n}\nu-fa-icon .fa-spotify:before {\n\n  content: '\\F1BC';\n}\nu-fa-icon .fa-deviantart:before {\n\n  content: '\\F1BD';\n}\nu-fa-icon .fa-soundcloud:before {\n\n  content: '\\F1BE';\n}\nu-fa-icon .fa-database:before {\n\n  content: '\\F1C0';\n}\nu-fa-icon .fa-file-pdf-o:before {\n\n  content: '\\F1C1';\n}\nu-fa-icon .fa-file-word-o:before {\n\n  content: '\\F1C2';\n}\nu-fa-icon .fa-file-excel-o:before {\n\n  content: '\\F1C3';\n}\nu-fa-icon .fa-file-powerpoint-o:before {\n\n  content: '\\F1C4';\n}\nu-fa-icon .fa-file-photo-o:before, u-fa-icon .fa-file-picture-o:before, u-fa-icon .fa-file-image-o:before {\n\n  content: '\\F1C5';\n}\nu-fa-icon .fa-file-zip-o:before, u-fa-icon .fa-file-archive-o:before {\n\n  content: '\\F1C6';\n}\nu-fa-icon .fa-file-sound-o:before, u-fa-icon .fa-file-audio-o:before {\n\n  content: '\\F1C7';\n}\nu-fa-icon .fa-file-movie-o:before, u-fa-icon .fa-file-video-o:before {\n\n  content: '\\F1C8';\n}\nu-fa-icon .fa-file-code-o:before {\n\n  content: '\\F1C9';\n}\nu-fa-icon .fa-vine:before {\n\n  content: '\\F1CA';\n}\nu-fa-icon .fa-codepen:before {\n\n  content: '\\F1CB';\n}\nu-fa-icon .fa-jsfiddle:before {\n\n  content: '\\F1CC';\n}\nu-fa-icon .fa-life-bouy:before, u-fa-icon .fa-life-saver:before, u-fa-icon .fa-support:before, u-fa-icon .fa-life-ring:before {\n\n  content: '\\F1CD';\n}\nu-fa-icon .fa-circle-o-notch:before {\n\n  content: '\\F1CE';\n}\nu-fa-icon .fa-ra:before, u-fa-icon .fa-rebel:before {\n\n  content: '\\F1D0';\n}\nu-fa-icon .fa-ge:before, u-fa-icon .fa-empire:before {\n\n  content: '\\F1D1';\n}\nu-fa-icon .fa-git-square:before {\n\n  content: '\\F1D2';\n}\nu-fa-icon .fa-git:before {\n\n  content: '\\F1D3';\n}\nu-fa-icon .fa-hacker-news:before {\n\n  content: '\\F1D4';\n}\nu-fa-icon .fa-tencent-weibo:before {\n\n  content: '\\F1D5';\n}\nu-fa-icon .fa-qq:before {\n\n  content: '\\F1D6';\n}\nu-fa-icon .fa-wechat:before, u-fa-icon .fa-weixin:before {\n\n  content: '\\F1D7';\n}\nu-fa-icon .fa-send:before, u-fa-icon .fa-paper-plane:before {\n\n  content: '\\F1D8';\n}\nu-fa-icon .fa-send-o:before, u-fa-icon .fa-paper-plane-o:before {\n\n  content: '\\F1D9';\n}\nu-fa-icon .fa-history:before {\n\n  content: '\\F1DA';\n}\nu-fa-icon .fa-circle-thin:before {\n\n  content: '\\F1DB';\n}\nu-fa-icon .fa-header:before {\n\n  content: '\\F1DC';\n}\nu-fa-icon .fa-paragraph:before {\n\n  content: '\\F1DD';\n}\nu-fa-icon .fa-sliders:before {\n\n  content: '\\F1DE';\n}\nu-fa-icon .fa-share-alt:before {\n\n  content: '\\F1E0';\n}\nu-fa-icon .fa-share-alt-square:before {\n\n  content: '\\F1E1';\n}\nu-fa-icon .fa-bomb:before {\n\n  content: '\\F1E2';\n}\n", ""]);

// exports


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UFooterComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__updater_ulytics__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__updater_ulytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__updater_ulytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_footer_component__ = __webpack_require__(78);




var UFooterComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-footer', [__WEBPACK_IMPORTED_MODULE_1__updater_ulytics__["UlyticsModule"].name]).component('uFooter', __WEBPACK_IMPORTED_MODULE_2__u_footer_component__["a" /* UFooterComponent */]);

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = require("@updater/ulytics");

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UFooterComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_footer_html__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_footer_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_footer_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_footer_controller_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_footer_global_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_footer_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__u_footer_global_css__);




var UFooterComponent = {
  bindings: {
    excludeLinkCodes: '=',
    footervariant: '<'
  },
  template: __WEBPACK_IMPORTED_MODULE_0__u_footer_html___default.a,
  controller: __WEBPACK_IMPORTED_MODULE_1__u_footer_controller_js__["a" /* UFooterController */]
};

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mg-bottom-medium\">\n  <div class=\"u-footer-container\">\n    <div class=\"u-footer-categories\">\n      <div\n        ng-if=\"!$ctrl.inVariant()\"\n        class=\"u-footer-category\"\n        ng-repeat=\"category in ::$ctrl.categories\"\n      >\n        <h6>\n          <i class=\"fa pulse fa-{{::category.icon}}\"></i>\n          {{category.name}}\n        </h6>\n        <div class=\"u-footer-category-content\">\n          <ul ng-if=\"category.links\">\n            <li ng-repeat=\"link in ::category.links\">\n              <a\n                class=\"category-link\"\n                ng-href=\"{{::link.href}}\"\n                ng-if=\"::$ctrl.showLink(link.code)\"\n                target=\"_blank\"\n                analytics-on\n                analytics-event=\"{{::link.event}}\"\n                ng-bind-html=\"::$ctrl.trustHtml(link.name)\"\n              >\n              </a>\n            </li>\n          </ul>\n          <div\n            class=\"social-links mg-top-small\"\n            ng-if=\"category.socialLinks\"\n          >\n            <a\n              class=\"ico-social-footer pop ico-{{::link.icon}}-footer\"\n              ng-repeat=\"link in ::category.socialLinks\"\n              ng-href=\"{{::link.href}}\"\n              target=\"_blank\"\n              analytics-on\n              analytics-event=\"::link.event\"\n            >\n            </a>\n          </div>\n        </div>\n      </div>\n      <div\n        ng-if=\"$ctrl.inVariant()\"\n        class=\"u-footer-category\"\n      >\n        <h6>\n          {{$ctrl.category.name}}\n        </h6>\n        <div class=\"u-footer-category-content\">\n            <ul ng-if=\"$ctrl.category.links\">\n              <li ng-repeat=\"link in ::$ctrl.category.links\">\n                <a\n                  class=\"category-link\"\n                  ng-href=\"{{::link.href}}\"\n                  ng-if=\"::$ctrl.showLink(link.code)\"\n                  target=\"_blank\"\n                  analytics-on\n                  analytics-event=\"{{::link.event}}\"\n                  ng-bind-html=\"::$ctrl.trustHtml(link.name)\"\n                >\n                </a>\n              </li>\n            </ul>\n          </div>\n      </div>\n    </div>\n    <div class=\"u-footer-legal-links mg-top-large\">\n      <div class=\"u-footer-legal-links-content\">\n        <span class=\"updater-copy-right\">&copy; {{$ctrl.year}} Updater</span>\n        <a\n          ng-if=\"!$ctrl.inVariant()\"\n          href=\"http://nytm.org/made-in-nyc\"\n          target=\"_blank\"\n          analytics-on\n          analytics-event=\"Clicked Footer Made In NYC Link\"\n        >\n          made with\n          <span class=\"heart\"><i class=\"fa fa-heart\"></i></span>\n          in NYC\n        </a>\n        <a\n          ng-href=\"{{$ctrl.updaterUrl}}/privacy\"\n          target=\"_blank\"\n          analytics-on\n          analytics-event=\"Clicked Footer Privacy Link\"\n        >\n          Privacy\n        </a>\n        <a\n          ng-href=\"{{$ctrl.updaterUrl}}/terms\"\n          target=\"_blank\"\n          analytics-on\n          analytics-event=\"Clicked Footer Terms Link\"\n        >\n          Terms\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UFooterController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_footer_constants__ = __webpack_require__(81);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var UFooterController = function () {
  UFooterController.$inject = ['$sce'];

  function UFooterController($sce) {
    'ngInject';

    _classCallCheck(this, UFooterController);

    this.year = new Date().getFullYear();
    this.updaterUrl = __WEBPACK_IMPORTED_MODULE_0__u_footer_constants__["a" /* UPDATER_URL */];
    this.trustHtml = $sce.trustAsHtml;
    this.categories = __WEBPACK_IMPORTED_MODULE_0__u_footer_constants__["b" /* U_FOOTER_CATEGORIES */];
    this.category = __WEBPACK_IMPORTED_MODULE_0__u_footer_constants__["c" /* U_FOOTER_CATEGORY */];
  }

  _createClass(UFooterController, [{
    key: 'showLink',
    value: function showLink(code) {
      return (this.excludeLinkCodes || []).indexOf(code) === -1;
    }
  }, {
    key: 'inVariant',
    value: function inVariant() {
      if (this.footervariant) {
        return this.footervariant.variation === "simplified_footer";
      }
      return false;
    }
  }]);

  return UFooterController;
}();

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return U_FOOTER_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return U_FOOTER_CATEGORY; });
var UPDATER_URL = 'https://www.updater.com';

var U_FOOTER_CATEGORIES = [{
  name: 'About Us',
  icon: 'heart-o',
  links: [{
    code: 'about',
    name: 'About',
    href: UPDATER_URL + '/about-us',
    event: 'Clicked Footer About Us Link'
  }, {
    code: 'team',
    name: 'Team',
    href: UPDATER_URL + '/team',
    event: 'Clicked Footer Team Link'
  }, {
    code: 'jobs',
    name: 'Jobs',
    href: UPDATER_URL + '/jobs',
    event: 'Clicked Footer Jobs Link'
  }, {
    code: 'press',
    name: 'Press',
    href: UPDATER_URL + '/press',
    event: 'Clicked Footer Press Link'
  }]
}, {
  name: 'Resources',
  icon: 'star-o',
  links: [{
    code: 'blog',
    name: 'Blog',
    href: UPDATER_URL + '/blog',
    event: 'Clicked Footer Blog Link'
  }, {
    code: 'moving_tips',
    name: 'Moving Tips &amp; Tricks',
    href: UPDATER_URL + '/moving-tips',
    event: 'Clicked Footer Moving Tips Link'
  }, {
    code: 'faqs',
    name: 'Support Center',
    href: 'http://help.updater.com',
    event: 'Clicked Footer FAQS Link'
  }]
}, {
  name: 'Talk To Us',
  icon: 'bullhorn',
  links: [{
    code: 'contact_us',
    name: 'Contact Us',
    href: UPDATER_URL + '/contact-us',
    event: 'Clicked Footer Contact Us Link'
  }],
  socialLinks: [{
    icon: 'facebook',
    href: '//facebook.com/updater',
    event: 'Clicked Footer Facebook Link'
  }, {
    icon: 'twitter',
    href: '//twitter.com/updater',
    event: 'Clicked Footer Twitter Link'
  }, {
    icon: 'linkedin',
    href: '//linkedin.com/company/updater',
    event: 'Clicked Footer LinkedIn Link'
  }]
}];

var U_FOOTER_CATEGORY = {
  name: 'Get Help',
  links: [{
    code: 'moving_tips',
    name: 'Moving Tips &amp; Tricks',
    href: UPDATER_URL + '/moving-tips',
    event: 'Clicked Footer Moving Tips Link'
  }, {
    code: 'faqs',
    name: 'Support Center',
    href: 'http://help.updater.com',
    event: 'Clicked Footer FAQS Link'
  }]
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(83);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-footer.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-footer.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ":root {\n  /* Pulled from font-awesome _variables.scss\n     TODO: Remove once we figure out how we're going to pull in fontawesome into\n     angular-common, if at all... */\n}\n.u-footer-container {\n  max-width: 75%;\n  margin: 0 auto;\n}\n.u-footer-container .u-footer-categories {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n}\n.u-footer-container .u-footer-categories .u-footer-category {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 100%;\n          flex: 1 1 100%;\n  max-width: 25%;\n  max-height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.u-footer-container .u-footer-categories .u-footer-category h6 {\n  font-size: 15px;\n  font-weight: bold;\n  color: #fb959a;\n  border-bottom: 1px solid #e4e4e5;\n  text-align: center;\n  margin-bottom: 14px;\n}\n.u-footer-container .u-footer-categories .u-footer-category h6 i {\n  font: normal normal normal 14px/1 FontAwesome;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  margin: -5px 7px 0 0;\n}\n.u-footer-container .u-footer-categories .u-footer-category .u-footer-category-content {\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  -ms-flex-line-pack: stretch;\n      align-content: stretch;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.u-footer-container .u-footer-categories .u-footer-category .u-footer-category-content ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.u-footer-container .u-footer-categories .u-footer-category .u-footer-category-content a.category-link {\n  color: #bababb;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: bold;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear\n}\n.u-footer-container .u-footer-categories .u-footer-category .u-footer-category-content a.category-link:hover {\n  color: #75c79b;\n  font-size: 15px;\n}\n.u-footer-container .u-footer-legal-links {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  -ms-flex-line-pack: stretch;\n      align-content: stretch;\n}\n.u-footer-container .u-footer-legal-links .u-footer-legal-links-content {\n  width: 375px;\n  font-size: 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.u-footer-container .u-footer-legal-links .u-footer-legal-links-content .updater-copy-right {\n  opacity: 0.5;\n}\n.u-footer-container .u-footer-legal-links .u-footer-legal-links-content .heart {\n  color: #f97179;\n}\n.u-footer-container .u-footer-legal-links .u-footer-legal-links-content a {\n  opacity: 0.5;\n  color: #666667;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear\n}\n.u-footer-container .u-footer-legal-links .u-footer-legal-links-content a:hover {\n  opacity: 1;\n}\n.u-footer-container .ico-social-footer {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: inline-block;\n  border-radius: 999px;\n  line-height: 1;\n  position: relative;\n  margin: 0 5px;\n  height: 38px;\n  width: 38px;\n  background-color: #ffffff;\n  border: 2px solid #efefef;\n  text-align: center;\n  text-indent: -9999px;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear\n}\n.u-footer-container .ico-social-footer:hover {\n  border: 2px solid #bababb;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.u-footer-container .ico-social-footer:hover:before {\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  color: #8c8c8d;\n}\n.u-footer-container .ico-social-footer:before {\n  font-family: FontAwesome;\n  position: absolute;\n  font-size: 19px;\n  color: #bababb;\n  top: 24%;\n  left: 0;\n  width: 100%;\n  text-indent: 0;\n}\n.u-footer-container .ico-facebook-footer {\n}\n.u-footer-container .ico-facebook-footer:before {\n  content: '\\F09A';\n}\n.u-footer-container .ico-twitter-footer {\n}\n.u-footer-container .ico-twitter-footer:before {\n  content: '\\F099';\n}\n.u-footer-container .ico-linkedin-footer {\n}\n.u-footer-container .ico-linkedin-footer:before {\n  content: '\\F0E1';\n}\n@media (max-width: 767px) {\n  .u-footer-container .u-footer-categories {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n  .u-footer-container .u-footer-categories .u-footer-category {\n    -webkit-box-flex: 0;\n        -ms-flex: 0;\n            flex: 0;\n    max-width: 100%;\n    width: 100%;\n  }\n}\n/* Pop Animation */\n@-webkit-keyframes pop {\n  50% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n@keyframes pop {\n  50% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n.pop {\n}\n.pop:hover, .pop:focus, .pop:active {\n  -webkit-animation: pop 1s linear 1;\n          animation: pop 1s linear 1;\n}\n/* Pulse Animation */\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n  }\n  50% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n  }\n}\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n  }\n  50% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n  }\n}\n.pulse {\n  -webkit-animation: pulse 1s linear infinite;\n          animation: pulse 1s linear infinite;\n}\n", ""]);

// exports


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gauge_module__ = __webpack_require__(85);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__gauge_module__["a"]; });


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GaugeModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gauge_component__ = __webpack_require__(86);



var GaugeModule = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.gauge', []).component('updGauge', __WEBPACK_IMPORTED_MODULE_1__gauge_component__["a" /* GaugeComponent */]);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GaugeComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gauge_utils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gauge_html__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gauge_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gauge_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gauge_global_css__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gauge_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gauge_global_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var GaugeController = function () {
  GaugeController.$inject = ['$element', '$timeout', '$interval'];

  function GaugeController($element, $timeout, $interval) {
    'ngInject';

    _classCallCheck(this, GaugeController);

    Object.assign(this, { $element: $element, $timeout: $timeout, $interval: $interval });
  }

  _createClass(GaugeController, [{
    key: '$onInit',
    value: function $onInit() {
      this.canvas = this.$element.find('canvas')[0];
    }
  }, {
    key: '$onChanges',
    value: function $onChanges() {
      var _this = this;

      this.$timeout(function () {
        return _this.doAnimate();
      });
    }
  }, {
    key: 'draw',
    value: function draw(degrees) {
      var circleOpts = {
        bgColor: this.bgColor,
        fillColor: this.fillColor,
        lineWidth: this.lineWidth
      };

      var drawing = new __WEBPACK_IMPORTED_MODULE_0__gauge_utils__["b" /* Drawing */](this.canvas);
      var circle = new __WEBPACK_IMPORTED_MODULE_0__gauge_utils__["a" /* Circle */](drawing.width, drawing.height, this.radius, circleOpts, parseInt(this.size, 10));

      circle.draw(drawing.ctx);

      if (degrees > 0) {
        circle.animate(drawing.ctx, degrees);
      }
    }
  }, {
    key: 'doAnimate',
    value: function doAnimate() {
      var _this2 = this;

      var degrees = 0;
      var finalDegs = this.degrees;

      // Function to make the chart move to new degrees
      var animateTo = function () {
        // Clear animation loop if degrees reaches to finalDegs
        if (degrees >= finalDegs) {
          _this2.$interval.cancel(_this2.animationLoop);
        }

        _this2.draw(degrees++);
      };

      // Handle when we don't want to animate, this will let it fill only
      if (this.animate === 'false') degrees = finalDegs;

      // Cancel any movement animation if a new chart is requested
      if (_typeof(this.animationLoop) !== undefined) {
        this.$interval.cancel(this.animationLoop);
      }

      this.animationLoop = this.$interval(animateTo, 1000 / finalDegs);
    }
  }, {
    key: 'lineWidth',
    get: function () {
      return 0.0875 * this.size;
    }
  }, {
    key: 'radius',
    get: function () {
      return 0.45 * this.size;
    }
  }, {
    key: 'degrees',
    get: function () {
      return Math.round(360 * Math.min(1, this.value));
    }
  }, {
    key: 'content',
    get: function () {
      return this.percentage ? Math.round(this.value * 100) + '%' : '' + this.value;
    }
  }]);

  return GaugeController;
}();

var GaugeComponent = {
  controller: GaugeController,
  bindings: {
    animate: '@',
    bgColor: '@',
    fillColor: '@',
    percentage: '<',
    size: '@',
    value: '<'
  },
  template: __WEBPACK_IMPORTED_MODULE_1__gauge_html___default.a
};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Drawing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Circle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_object_defaults__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_object_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_object_defaults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Drawing = function () {
  function Drawing(canvas) {
    _classCallCheck(this, Drawing);

    this.canvas = canvas;
    this.width = canvas.width;
    this.height = canvas.height;
    this.ctx = canvas.getContext('2d');

    // Clear the drawing context every time
    this.clear();
  }

  _createClass(Drawing, [{
    key: 'clear',
    value: function clear() {
      this.ctx.clearRect(0, 0, this.width, this.height);
    }
  }]);

  return Drawing;
}();

var Circle = function () {
  function Circle(width, height, radius, options, size) {
    _classCallCheck(this, Circle);

    var defaultOptions = {
      bgColor: '#ccc',
      fillColor: '#000'
    };

    this.width = width;
    this.height = height;
    this.radius = radius;
    this.size = size;
    this.options = __WEBPACK_IMPORTED_MODULE_0_lodash_object_defaults___default()({}, options, defaultOptions);

    return this;
  }

  _createClass(Circle, [{
    key: 'animate',
    value: function animate(ctx, degrees, options) {
      options = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.merge({}, this.options, options);
      var radians = degrees * Math.PI / 180; // Angle in radians = angle in degrees * PI/180
      var offset = 90 * Math.PI / 180;

      ctx.beginPath();
      ctx.strokeStyle = options.fillColor;
      ctx.lineWidth = options.lineWidth;
      // The arc starts from the rightmost end. If we deduct 90 degrees from the angles
      // the arc will start from the topmost end
      ctx.arc(this.width / 2, this.height / 2, this.radius, 0 - offset, radians - offset, false);
      ctx.stroke();
    }
  }, {
    key: 'draw',
    value: function draw(ctx) {
      var opts = this.options;

      ctx.beginPath();
      ctx.strokeStyle = opts.bgColor;
      ctx.lineWidth = opts.lineWidth;
      ctx.arc(this.width / 2, this.height / 2, this.radius, 0, Math.PI * 2, false);
      ctx.stroke();
    }
  }]);

  return Circle;
}();

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var assign = __webpack_require__(89),
    assignDefaults = __webpack_require__(99),
    createDefaults = __webpack_require__(100);

/**
 * Assigns own enumerable properties of source object(s) to the destination
 * object for all destination properties that resolve to `undefined`. Once a
 * property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
 * // => { 'user': 'barney', 'age': 36 }
 */
var defaults = createDefaults(assign, assignDefaults);

module.exports = defaults;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var assignWith = __webpack_require__(90),
    baseAssign = __webpack_require__(94),
    createAssigner = __webpack_require__(96);

/**
 * Assigns own enumerable properties of source object(s) to the destination
 * object. Subsequent sources overwrite property assignments of previous sources.
 * If `customizer` is provided it's invoked to produce the assigned values.
 * The `customizer` is bound to `thisArg` and invoked with five arguments:
 * (objectValue, sourceValue, key, object, source).
 *
 * **Note:** This method mutates `object` and is based on
 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
 *
 * @static
 * @memberOf _
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
 * // => { 'user': 'fred', 'age': 40 }
 *
 * // using a customizer callback
 * var defaults = _.partialRight(_.assign, function(value, other) {
 *   return _.isUndefined(value) ? other : value;
 * });
 *
 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
 * // => { 'user': 'barney', 'age': 36 }
 */
var assign = createAssigner(function(object, source, customizer) {
  return customizer
    ? assignWith(object, source, customizer)
    : baseAssign(object, source);
});

module.exports = assign;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var keys = __webpack_require__(11);

/**
 * A specialized version of `_.assign` for customizing assigned values without
 * support for argument juggling, multiple sources, and `this` binding `customizer`
 * functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 */
function assignWith(object, source, customizer) {
  var index = -1,
      props = keys(source),
      length = props.length;

  while (++index < length) {
    var key = props[index],
        value = object[key],
        result = customizer(value, source[key], key, object, source);

    if ((result === result ? (result !== value) : (value === value)) ||
        (value === undefined && !(key in object))) {
      object[key] = result;
    }
  }
  return object;
}

module.exports = assignWith;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(20),
    isObjectLike = __webpack_require__(3);

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isNative;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(13),
    isArray = __webpack_require__(5),
    isIndex = __webpack_require__(10),
    isLength = __webpack_require__(7),
    keysIn = __webpack_require__(93);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = shimKeys;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(13),
    isArray = __webpack_require__(5),
    isIndex = __webpack_require__(10),
    isLength = __webpack_require__(7),
    isObject = __webpack_require__(4);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var baseCopy = __webpack_require__(95),
    keys = __webpack_require__(11);

/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return source == null
    ? object
    : baseCopy(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */
function baseCopy(source, props, object) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    object[key] = source[key];
  }
  return object;
}

module.exports = baseCopy;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var bindCallback = __webpack_require__(97),
    isIterateeCall = __webpack_require__(9),
    restParam = __webpack_require__(21);

/**
 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return restParam(function(object, sources) {
    var index = -1,
        length = object == null ? 0 : sources.length,
        customizer = length > 2 ? sources[length - 2] : undefined,
        guard = length > 2 ? sources[2] : undefined,
        thisArg = length > 1 ? sources[length - 1] : undefined;

    if (typeof customizer == 'function') {
      customizer = bindCallback(customizer, thisArg, 5);
      length -= 2;
    } else {
      customizer = typeof thisArg == 'function' ? thisArg : undefined;
      length -= (customizer ? 1 : 0);
    }
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(98);

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

module.exports = bindCallback;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/**
 * Used by `_.defaults` to customize its `_.assign` use.
 *
 * @private
 * @param {*} objectValue The destination object property value.
 * @param {*} sourceValue The source object property value.
 * @returns {*} Returns the value to assign to the destination object.
 */
function assignDefaults(objectValue, sourceValue) {
  return objectValue === undefined ? sourceValue : objectValue;
}

module.exports = assignDefaults;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var restParam = __webpack_require__(21);

/**
 * Creates a `_.defaults` or `_.defaultsDeep` function.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Function} Returns the new defaults function.
 */
function createDefaults(assigner, customizer) {
  return restParam(function(args) {
    var object = args[0];
    if (object == null) {
      return object;
    }
    args.push(customizer);
    return assigner.apply(undefined, args);
  });
}

module.exports = createDefaults;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<canvas width=\"{{ ::$ctrl.size }}\" height=\"{{ ::$ctrl.size }}\"></canvas>\n\n<div class=\"content\">\n  <span>{{ $ctrl.content }}</span>\n</div>\n"

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(103);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./gauge.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./gauge.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "upd-gauge {\n  position: relative;\n}\nupd-gauge canvas {\n  display: block;\n  width: 100%;\n}\nupd-gauge .content {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UProviderCardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_provider_card_component__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__updater_ui_card__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__updater_ui_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__updater_ui_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__updater_ui_tooltip__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__updater_ui_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__updater_ui_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__updater_ui_cta__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__updater_ui_cta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__updater_ui_cta__);







var UProviderCardComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-provider-card', [__WEBPACK_IMPORTED_MODULE_2__filters__["b" /* PhoneNumberFilter */].name, __WEBPACK_IMPORTED_MODULE_2__filters__["a" /* DynamicFilter */].name, __WEBPACK_IMPORTED_MODULE_2__filters__["c" /* ReduceToPropertyFilter */].name]).component('uProviderCard', __WEBPACK_IMPORTED_MODULE_1__u_provider_card_component__["a" /* UProviderCardComponent */]);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UProviderCardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_provider_card_html__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_provider_card_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_provider_card_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_provider_card_controller__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_provider_card_global_css__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_provider_card_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__u_provider_card_global_css__);




var UProviderCardComponent = {
  transclude: {
    actions: '?uProviderCardActions'
  },
  bindings: {
    provider: '=',
    logoBaseUrl: '@',
    displayNameFilter: '@',
    analytics: '='
  },
  template: __WEBPACK_IMPORTED_MODULE_0__u_provider_card_html___default.a,
  controller: __WEBPACK_IMPORTED_MODULE_1__u_provider_card_controller__["a" /* UProviderCardController */]
};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<upd-card class=\"provider-card\">\n  <div class=\"provider-card-content\"> \n    <div class=\"provider-logo mg-top-small\">\n    <img ng-src=\"{{::$ctrl.logoUrl}}\" />\n  </div>\n\n  <ut-provider-card-content>\n    <div class=\"provider-company\">\n      <div class=\"md-title\">\n        <span>{{::$ctrl.title}}</span>\n      </div>\n    </div>\n\n    <div class=\"provider-description text-muted small mg-bottom-medium\">\n      <span>{{$ctrl.provider.description}}</span>\n    </div>\n\n    <div class=\"provider-detail mg-bottom-medium\">\n      <span>{{::$ctrl.provider.detail}}</span>\n    </div>\n\n    <div class=\"provider-contact-info mg-bottom-medium\">\n      <div class=\"contact-item\">\n        <span>{{::$ctrl.provider.contact_detail}}</span>\n      </div>\n\n      <div class=\"contact-item\">\n        <u-provider-mobile-view>\n          <span>{{::($ctrl.provider.phone | phoneNumber)}}</span>\n        </u-provider-mobile-view>\n\n        <u-provider-desktop-view>\n          <a ng-href=\"tel:{{::$ctrl.provider.phone}}\">{{::($ctrl.provider.phone | phoneNumber)}}</a>\n        </u-provider-desktop-view>\n      </div>\n\n      <div class=\"contact-item\">\n        <upd-tooltip enabled label=\"{{::$ctrl.provider.email}}\">\n          <div class=\"contact-email\">\n            <a ng-href=\"mailto:{{::$ctrl.provider.email}}\">{{::$ctrl.provider.email}}</a>\n          </div>\n        </upd-tooltip>\n      </div>\n    </div>\n  </ut-provider-card-content>\n  \n  <div>\n    <upd-cta primary ng-if=\"$ctrl.provider.link\" class=\"provider-cta\">\n      <a\n        ng-href=\"{{::$ctrl.provider.link}}\"\n        target=\"_blank\"\n        analytics-on\n        analytics-if=\"{{!!$ctrl.analytics}}\"\n        analytics-event=\"{{::$ctrl.analytics.eventName}}\"\n        analytics-properties=\"{{::$ctrl.analytics.properties}}\"\n      >\n        VISIT ONLINE\n      </a>\n    </upd-cta>\n  </div>\n\n  <u-provider-card-actions-wrapper ng-transclude=\"actions\"></u-provider-card-actions-wrapper>\n\n  </div>\n\n</upd-card>\n"

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UProviderCardController; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UProviderCardController = function () {
  UProviderCardController.$inject = ['$filter'];

  function UProviderCardController($filter) {
    'ngInject';

    _classCallCheck(this, UProviderCardController);

    this.filter = $filter('dynamicFilter');
  }

  _createClass(UProviderCardController, [{
    key: '$onInit',
    value: function $onInit() {
      this.defaultDisplayNameFilter = 'reduceToProperty:name';
      this.displayNameFilter = this.displayNameFilter || this.defaultDisplayNameFilter;
    }
  }, {
    key: 'title',
    get: function () {
      return this.filter(this.provider, this.displayNameFilter) || this.filter(this.provider, this.defaultDisplayNameFilter);
    }
  }, {
    key: 'logoUrl',
    get: function () {
      return this.logoBaseUrl + '/' + this.provider.logo_id;
    }
  }]);

  return UProviderCardController;
}();

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(109);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-provider-card.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-provider-card.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/* Breakpoint values taken from our original bootstrap setup:\n  xs: 480px\n  sm: 768px\n  md: 992px\n  lg: 1200px\n*/\n\n/*\n  Used to declare these as variables, but no longer works:\n  https://github.com/MoOx/postcss-cssnext/issues/262;\n*/\n\n.provider-card {\n  width: 100%;\n  text-align: center;\n  padding: 16px;\n\n  /* Makes sure the cards are always the same height when laid out in a row. */\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n\n  /* Keeps IE11 from overflowing even though `md-card` is the only child. */\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.provider-card .provider-card-content {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.provider-card md-card {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;/* Fixes IE11 issue where `md-card` doesn't fill its parent vertically. */\n  -ms-flex-preferred-size: auto;\n      flex-basis: auto;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n}\n\n.provider-card ut-provider-card-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n}\n\n.provider-card .provider-logo {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 80px;\n}\n\n.provider-card .provider-logo img {\n  max-width: 150px;\n  max-height: 80px;\n}\n\n.provider-card .provider-contact-info {\n  line-height: 20px;\n  text-align: center;\n}\n\n.provider-card .provider-contact-info a {\n  text-decoration: underline;\n}\n\n.provider-card .provider-contact-info .contact-item {}\n\n.provider-card .provider-contact-info .contact-email {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.provider-card ut-provider-card-content {\n  width: 100%;\n  word-wrap: break-word;\n}\n\n.provider-card .provider-company .md-title {\n  margin: 15px 0;\n}\n\n/* Should be tall enough to accomodate 2 lines of text to maintain equal height.\n     Doesn't matter on mobile. */\n\n.provider-card .provider-description {}\n\n/* Should be tall enough to accomodate 2 lines of text to maintain equal height.\n     Doesn't matter on mobile. */\n\n.provider-card .provider-detail {}\n\n.provider-card .provider-cta {/* As the last item, push to bottom of card to align with other cards. */\n  text-align: center;\n  margin: auto 8px 6px 8px\n}\n\n.provider-card .provider-cta > a {\n  padding: 12px 24px;\n  min-height: 43px;\n  background-color: #2b7499;\n  color: #fff;\n}\n\n.provider-card u-provider-card-actions-wrapper {\n  margin: 0;\n  background-color: #efefef;/* \"Hide\" this section by default. We don't want to show any of it unless action items\n       are included in the `u-content`.\n       TODO: Figure out better way of doing this. */\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n\n/* Present if something has been added to parent via `u-content`. */\n\n.provider-card u-provider-card-actions-wrapper .ng-scope {\n  padding: 8px;\n}\n\n@media (max-width: 767px) {\n\n  .provider-card {\n    min-height: 0;\n  }\n  }\n\n@media (min-width: 768px) {\n\n  .provider-card {\n    width: 350px;\n  }\n  }\n\n@media (min-width: 768px) {\n\n  .provider-card .provider-contact-info .contact-item {\n    min-height: 20px;\n  }\n      }\n\n@media (min-width: 768px) {\n\n  .provider-card .provider-description {\n    min-height: 50px;\n  }\n    }\n\n@media (min-width: 768px) {\n\n  .provider-card .provider-detail {\n    min-height: 70px;\n  }\n    }\n\n@media (min-width: 768px) {\n\n  .provider-card .provider-cta {}\n\n  .provider-card .provider-cta > a {\n    min-height: 50px;\n  }\n    }\n\n@media (max-width: 767px) {\n\n  .provider-card u-provider-desktop-view {\n    display: none;\n  }\n  }\n\n@media (min-width: 768px) {\n\n  .provider-card u-provider-mobile-view {\n    display: none;\n  }\n  }\n\n@media (min-width: 768px) {\n\n  .provider-card upd-card {\n    height: 100%;\n  }\n  }\n\n", ""]);

// exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dynamic_filter__ = __webpack_require__(111);



var DynamicFilter = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.filters.dynamic-filter', []).filter('dynamicFilter', __WEBPACK_IMPORTED_MODULE_1__dynamic_filter__["a" /* DynamicFilter */]);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DynamicFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

DynamicFilter.$inject = ['$filter'];


/**
 * Allows for dynamically assigning filters in templates.
 * E.g.: in controller: $scope.nameFilter = 'uppercase'
 *       in template:   {{item | dynamicFilter:nameFilter}}
 *
 * Filter arguments (in addition to input) can be passed using
 * ":" as a separator.
 * E.g.: in controller: $scope.nameFilter = 'limitTo:0:20'
 *       in template:   {{item | dynamicFilter:nameFilter}}
 */
function DynamicFilter($filter) {
  'ngInject';

  return function (input, filter) {
    if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isString(filter)) {
      var split = filter.split(':');
      var args = [input].concat(split.slice(1));
      filter = split[0];
      return $filter(filter).apply(null, args);
    } else if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(filter)) {
      return filter(input);
    } else {
      throw new Error('dynamicFilter: filter must be either an Array or String. Got ' + (typeof filter === 'undefined' ? 'undefined' : _typeof(filter)) + '.');
    }
  };
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumberFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__phone_number_filter__ = __webpack_require__(113);



var PhoneNumberFilter = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.filters.phone-number', []).filter('phoneNumber', __WEBPACK_IMPORTED_MODULE_1__phone_number_filter__["a" /* PhoneNumberFilter */]);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PhoneNumberFilter;
function PhoneNumberFilter() {
  return function (input) {
    var ext = void 0;

    // Assumes the the extension is the only A-Z character in the number
    var split = (input || '').split(/[a-zA-Z]+/);

    // Strip all non-numeric values from the phone number
    var number = split[0].replace(/\D/g, '').trim();

    // Remove the . if it exists
    if (split[1]) {
      ext = split[1].replace(/^\./, '').trim();
    }

    // Remove country code if it exists
    if (number.length === 11) {
      number = number.substr(1);
    }

    // Exit early if the number is empty
    if (!number) {
      return '';
    }

    // Format the phone number
    var areaCode = number.substr(0, 3);
    var exchange = number.substr(3, 3);
    var subscriber = number.substr(6, 4);
    var formatted = '(' + areaCode + ') ' + exchange + '-' + subscriber;

    // Apply the extension if it exists
    if (ext) {
      formatted += ' x' + ext;
    }

    return formatted.trim();
  };
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReduceToPropertyFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduce_to_property__ = __webpack_require__(115);



var ReduceToPropertyFilter = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.filters.reduce-to-property', []).filter('reduceToProperty', __WEBPACK_IMPORTED_MODULE_1__reduce_to_property__["a" /* ReduceToPropertyFilter */]);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReduceToPropertyFilter;
/**
 * Returns a property from an object.
 */
function ReduceToPropertyFilter() {
  return function (input, propertyName) {
    return input[propertyName];
  };
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TitleizeFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__titleize_filter__ = __webpack_require__(117);



var TitleizeFilter = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.filters.titleize', []).filter('titleizeFilter', __WEBPACK_IMPORTED_MODULE_1__titleize_filter__["a" /* TitleizeFilter */]);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TitleizeFilter;
function TitleizeFilter() {
  return function (input) {
    // https://github.com/sindresorhus/titleize
    return (input || '').toLowerCase().replace(/(?:^|\s|-)\S/g, function (s) {
      return s.toUpperCase();
    });
  };
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZipCodeFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zip_code_filter__ = __webpack_require__(119);



var ZipCodeFilter = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.filters.zip-code', []).filter('zipCode', __WEBPACK_IMPORTED_MODULE_1__zip_code_filter__["a" /* ZipCodeFilter */]);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZipCodeFilter;
function ZipCodeFilter() {
  return function (zip) {
    return (zip || '').substring(0, 5);
  };
}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = require("@updater/ui-card");

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = require("@updater/ui-tooltip");

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = require("@updater/ui-cta");

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UTableComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shims_ng_table_shim__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_table_header_sortable__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__u_table_service__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__u_table_global_css__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__u_table_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__u_table_global_css__);






var UTableComponent = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.components.u-table', [__WEBPACK_IMPORTED_MODULE_2__u_table_header_sortable__["a" /* UTableHeaderSortableDirective */].name, __WEBPACK_IMPORTED_MODULE_1__shims_ng_table_shim__["a" /* default */].name]).service('uTable', __WEBPACK_IMPORTED_MODULE_3__u_table_service__["a" /* UTableService */]);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_ng_table_dist_ng_table_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_ng_table_dist_ng_table_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_ng_table_dist_ng_table_js__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('ngTable'));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(angular, factory) {
    'use strict';

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(angular) {
            return factory(angular);
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        return factory(angular);
    }
}(window.angular || null, function(angular) {
    'use strict';

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc module
 * @name ngTable
 * @description ngTable: Table + Angular JS
 * @example
 <doc:example>
 <doc:source>
 <script>
 var app = angular.module('myApp', ['ngTable']);
 app.controller('MyCtrl', function($scope) {
                    $scope.users = [
                        {name: "Moroni", age: 50},
                        {name: "Tiancum", age: 43},
                        {name: "Jacob", age: 27},
                        {name: "Nephi", age: 29},
                        {name: "Enos", age: 34}
                    ];
                });
 </script>
 <table ng-table class="table">
 <tr ng-repeat="user in users">
 <td data-title="'Name'">{{user.name}}</td>
 <td data-title="'Age'">{{user.age}}</td>
 </tr>
 </table>
 </doc:source>
 </doc:example>
 */
var app = angular.module('ngTable', []);
/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc value
 * @name ngTable.value:ngTableDefaultParams
 * @description Default Parameters for ngTable
 */
app.value('ngTableDefaults', {
    params: {},
    settings: {}
});

/**
 * @ngdoc service
 * @name ngTable.factory:NgTableParams
 * @description Parameters manager for ngTable
 */

app.factory('NgTableParams', ['$q', '$log', 'ngTableDefaults', function($q, $log, ngTableDefaults) {
    var isNumber = function(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    var NgTableParams = function(baseParameters, baseSettings) {
        var self = this,
            log = function() {
                if (settings.debugMode && $log.debug) {
                    $log.debug.apply(this, arguments);
                }
            };

        this.data = [];

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#parameters
         * @methodOf ngTable.factory:NgTableParams
         * @description Set new parameters or get current parameters
         *
         * @param {string} newParameters      New parameters
         * @param {string} parseParamsFromUrl Flag if parse parameters like in url
         * @returns {Object} Current parameters or `this`
         */
        this.parameters = function(newParameters, parseParamsFromUrl) {
            parseParamsFromUrl = parseParamsFromUrl || false;
            if (angular.isDefined(newParameters)) {
                for (var key in newParameters) {
                    var value = newParameters[key];
                    if (parseParamsFromUrl && key.indexOf('[') >= 0) {
                        var keys = key.split(/\[(.*)\]/).reverse()
                        var lastKey = '';
                        for (var i = 0, len = keys.length; i < len; i++) {
                            var name = keys[i];
                            if (name !== '') {
                                var v = value;
                                value = {};
                                value[lastKey = name] = (isNumber(v) ? parseFloat(v) : v);
                            }
                        }
                        if (lastKey === 'sorting') {
                            params[lastKey] = {};
                        }
                        params[lastKey] = angular.extend(params[lastKey] || {}, value[lastKey]);
                    } else {
                        params[key] = (isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key]);
                    }
                }
                log('ngTable: set parameters', params);
                return this;
            }
            return params;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#settings
         * @methodOf ngTable.factory:NgTableParams
         * @description Set new settings for table
         *
         * @param {string} newSettings New settings or undefined
         * @returns {Object} Current settings or `this`
         */
        this.settings = function(newSettings) {
            if (angular.isDefined(newSettings)) {
                if (angular.isArray(newSettings.data)) {
                    //auto-set the total from passed in data
                    newSettings.total = newSettings.data.length;
                }
                settings = angular.extend(settings, newSettings);
                log('ngTable: set settings', settings);
                return this;
            }
            return settings;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#page
         * @methodOf ngTable.factory:NgTableParams
         * @description If parameter page not set return current page else set current page
         *
         * @param {string} page Page number
         * @returns {Object|Number} Current page or `this`
         */
        this.page = function(page) {
            return angular.isDefined(page) ? this.parameters({
                'page': page
            }) : params.page;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#total
         * @methodOf ngTable.factory:NgTableParams
         * @description If parameter total not set return current quantity else set quantity
         *
         * @param {string} total Total quantity of items
         * @returns {Object|Number} Current page or `this`
         */
        this.total = function(total) {
            return angular.isDefined(total) ? this.settings({
                'total': total
            }) : settings.total;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#count
         * @methodOf ngTable.factory:NgTableParams
         * @description If parameter count not set return current count per page else set count per page
         *
         * @param {string} count Count per number
         * @returns {Object|Number} Count per page or `this`
         */
        this.count = function(count) {
            // reset to first page because can be blank page
            return angular.isDefined(count) ? this.parameters({
                'count': count,
                'page': 1
            }) : params.count;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#filter
         * @methodOf ngTable.factory:NgTableParams
         * @description If parameter page not set return current filter else set current filter
         *
         * @param {string} filter New filter
         * @returns {Object} Current filter or `this`
         */
        this.filter = function(filter) {
            return angular.isDefined(filter) ? this.parameters({
                'filter': filter,
                'page': 1
            }) : params.filter;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#sorting
         * @methodOf ngTable.factory:NgTableParams
         * @description If 'sorting' parameter is not set, return current sorting. Otherwise set current sorting.
         *
         * @param {string} sorting New sorting
         * @returns {Object} Current sorting or `this`
         */
        this.sorting = function(sorting) {
            if (arguments.length == 2) {
                var sortArray = {};
                sortArray[sorting] = arguments[1];
                this.parameters({
                    'sorting': sortArray
                });
                return this;
            }
            return angular.isDefined(sorting) ? this.parameters({
                'sorting': sorting
            }) : params.sorting;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#isSortBy
         * @methodOf ngTable.factory:NgTableParams
         * @description Checks sort field
         *
         * @param {string} field     Field name
         * @param {string} direction Direction of sorting 'asc' or 'desc'
         * @returns {Array} Return true if field sorted by direction
         */
        this.isSortBy = function(field, direction) {
            return angular.isDefined(params.sorting[field]) && angular.equals(params.sorting[field], direction);
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#orderBy
         * @methodOf ngTable.factory:NgTableParams
         * @description Return object of sorting parameters for angular filter
         *
         * @returns {Array} Array like: [ '-name', '+age' ]
         */
        this.orderBy = function() {
            var sorting = [];
            for (var column in params.sorting) {
                sorting.push((params.sorting[column] === "asc" ? "+" : "-") + column);
            }
            return sorting;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#getData
         * @methodOf ngTable.factory:NgTableParams
         * @description Called when updated some of parameters for get new data
         *
         * @param {Object} $defer promise object
         * @param {Object} params New parameters
         */
        this.getData = function($defer, params) {
            if (angular.isArray(this.data) && angular.isObject(params)) {
                $defer.resolve(this.data.slice((params.page() - 1) * params.count(), params.page() * params.count()));
            } else {
                $defer.resolve([]);
            }
            return $defer.promise;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#getGroups
         * @methodOf ngTable.factory:NgTableParams
         * @description Return groups for table grouping
         */
        this.getGroups = function($defer, column) {
            var defer = $q.defer();

            defer.promise.then(function(data) {
                var groups = {};
                angular.forEach(data, function(item) {
                    var groupName = angular.isFunction(column) ? column(item) : item[column];

                    groups[groupName] = groups[groupName] || {
                        data: []
                    };
                    groups[groupName]['value'] = groupName;
                    groups[groupName].data.push(item);
                });
                var result = [];
                for (var i in groups) {
                    result.push(groups[i]);
                }
                log('ngTable: refresh groups', result);
                $defer.resolve(result);
            });
            return this.getData(defer, self);
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#generatePagesArray
         * @methodOf ngTable.factory:NgTableParams
         * @description Generate array of pages
         *
         * @param {boolean} currentPage which page must be active
         * @param {boolean} totalItems  Total quantity of items
         * @param {boolean} pageSize    Quantity of items on page
         * @returns {Array} Array of pages
         */
        this.generatePagesArray = function(currentPage, totalItems, pageSize) {
            var maxBlocks, maxPage, maxPivotPages, minPage, numPages, pages;
            maxBlocks = 11;
            pages = [];
            numPages = Math.ceil(totalItems / pageSize);
            if (numPages > 1) {
                pages.push({
                    type: 'prev',
                    number: Math.max(1, currentPage - 1),
                    active: currentPage > 1
                });
                pages.push({
                    type: 'first',
                    number: 1,
                    active: currentPage > 1,
                    current: currentPage === 1
                });
                maxPivotPages = Math.round((maxBlocks - 5) / 2);
                minPage = Math.max(2, currentPage - maxPivotPages);
                maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
                minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
                var i = minPage;
                while (i <= maxPage) {
                    if ((i === minPage && i !== 2) || (i === maxPage && i !== numPages - 1)) {
                        pages.push({
                            type: 'more',
                            active: false
                        });
                    } else {
                        pages.push({
                            type: 'page',
                            number: i,
                            active: currentPage !== i,
                            current: currentPage === i
                        });
                    }
                    i++;
                }
                pages.push({
                    type: 'last',
                    number: numPages,
                    active: currentPage !== numPages,
                    current: currentPage === numPages
                });
                pages.push({
                    type: 'next',
                    number: Math.min(numPages, currentPage + 1),
                    active: currentPage < numPages
                });
            }
            return pages;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#url
         * @methodOf ngTable.factory:NgTableParams
         * @description Return groups for table grouping
         *
         * @param {boolean} asString flag indicates return array of string or object
         * @returns {Array} If asString = true will be return array of url string parameters else key-value object
         */
        this.url = function(asString) {
            asString = asString || false;
            var pairs = (asString ? [] : {});
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var item = params[key],
                        name = encodeURIComponent(key);
                    if (typeof item === "object") {
                        for (var subkey in item) {
                            if (!angular.isUndefined(item[subkey]) && item[subkey] !== "") {
                                var pname = name + "[" + encodeURIComponent(subkey) + "]";
                                if (asString) {
                                    pairs.push(pname + "=" + item[subkey]);
                                } else {
                                    pairs[pname] = item[subkey];
                                }
                            }
                        }
                    } else if (!angular.isFunction(item) && !angular.isUndefined(item) && item !== "") {
                        if (asString) {
                            pairs.push(name + "=" + encodeURIComponent(item));
                        } else {
                            pairs[name] = encodeURIComponent(item);
                        }
                    }
                }
            }
            return pairs;
        };

        /**
         * @ngdoc method
         * @name ngTable.factory:NgTableParams#reload
         * @methodOf ngTable.factory:NgTableParams
         * @description Reload table data
         */
        this.reload = function() {
            var $defer = $q.defer(),
                self = this,
                pData = null;

            if (!settings.$scope) {
                return;
            }

            settings.$loading = true;
            if (settings.groupBy) {
                pData = settings.getGroups($defer, settings.groupBy, this);
            } else {
                pData = settings.getData($defer, this);
            }
            log('ngTable: reload data');

            if (!pData) {
                // If getData resolved the $defer, and didn't promise us data,
                //   create a promise from the $defer. We need to return a promise.
                pData = $defer.promise;
            }
            return pData.then(function(data) {
                settings.$loading = false;
                log('ngTable: current scope', settings.$scope);
                if (settings.groupBy) {
                    self.data = data;
                    if (settings.$scope) settings.$scope.$groups = data;
                } else {
                    self.data = data;
                    if (settings.$scope) settings.$scope.$data = data;
                }
                if (settings.$scope) settings.$scope.pages = self.generatePagesArray(self.page(), self.total(), self.count());
                settings.$scope.$emit('ngTableAfterReloadData');
                return data;
            });
        };

        this.reloadPages = function() {
            var self = this;
            settings.$scope.pages = self.generatePagesArray(self.page(), self.total(), self.count());
        };

        var params = this.$params = {
            page: 1,
            count: 1,
            filter: {},
            sorting: {},
            group: {},
            groupBy: null
        };
        angular.extend(params, ngTableDefaults.params);

        var settings = {
            $scope: null, // set by ngTable controller
            $loading: false,
            data: null, //allows data to be set when table is initialized
            total: 0,
            defaultSort: 'desc',
            filterDelay: 750,
            counts: [10, 25, 50, 100],
            sortingIndicator: 'span',
            getGroups: this.getGroups,
            getData: this.getData
        };
        angular.extend(settings, ngTableDefaults.settings);

        this.settings(baseSettings);
        this.parameters(baseParameters, true);
        return this;
    };
    return NgTableParams;
}]);

/**
 * @ngdoc service
 * @name ngTable.factory:ngTableParams
 * @description Backwards compatible shim for lowercase 'n' in NgTableParams
 */
app.factory('ngTableParams', ['NgTableParams', function(NgTableParams) {
    return NgTableParams;
}]);

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc object
 * @name ngTable.directive:ngTable.ngTableController
 *
 * @description
 * Each {@link ngTable.directive:ngTable ngTable} directive creates an instance of `ngTableController`
 */
app.controller('ngTableController', ['$scope', 'NgTableParams', '$timeout', '$parse', '$compile', '$attrs', '$element',
    'ngTableColumn',
function($scope, NgTableParams, $timeout, $parse, $compile, $attrs, $element, ngTableColumn) {
    var isFirstTimeLoad = true;
    $scope.$filterRow = {};
    $scope.$loading = false;

    // until such times as the directive uses an isolated scope, we need to ensure that the check for
    // the params field only consults the "own properties" of the $scope. This is to avoid seeing the params
    // field on a $scope higher up in the prototype chain
    if (!$scope.hasOwnProperty("params")) {
        $scope.params = new NgTableParams();
        $scope.params.isNullInstance = true;
    }
    $scope.params.settings().$scope = $scope;

    var delayFilter = (function() {
        var timer = 0;
        return function(callback, ms) {
            $timeout.cancel(timer);
            timer = $timeout(callback, ms);
        };
    })();

    function resetPage() {
        $scope.params.$params.page = 1;
    }

    $scope.$watch('params.$params', function(newParams, oldParams) {

        if (newParams === oldParams) {
            return;
        }

        $scope.params.settings().$scope = $scope;

        if (!angular.equals(newParams.filter, oldParams.filter)) {
            var maybeResetPage = isFirstTimeLoad ? angular.noop : resetPage;
            delayFilter(function() {
                maybeResetPage();
                $scope.params.reload();
            }, $scope.params.settings().filterDelay);
        } else {
            $scope.params.reload();
        }

        if (!$scope.params.isNullInstance) {
            isFirstTimeLoad = false;
        }

    }, true);

    this.compileDirectiveTemplates = function () {
        if (!$element.hasClass('ng-table')) {
            $scope.templates = {
                header: ($attrs.templateHeader ? $attrs.templateHeader : 'ng-table/header.html'),
                pagination: ($attrs.templatePagination ? $attrs.templatePagination : 'ng-table/pager.html')
            };
            $element.addClass('ng-table');
            var headerTemplate = null;
            if ($element.find('> thead').length === 0) {
                headerTemplate = angular.element(document.createElement('thead')).attr('ng-include', 'templates.header');
                $element.prepend(headerTemplate);
            }
            var paginationTemplate = angular.element(document.createElement('div')).attr({
                'ng-table-pagination': 'params',
                'template-url': 'templates.pagination'
            });
            $element.after(paginationTemplate);
            if (headerTemplate) {
                $compile(headerTemplate)($scope);
            }
            $compile(paginationTemplate)($scope);
        }
    };

    this.loadFilterData = function ($columns) {
        angular.forEach($columns, function ($column) {
            var def;
            def = $column.filterData($scope, {
                $column: $column
            });
            if (!def) {
                delete $column.filterData;
                return;
            }

            // if we're working with a deferred object, let's wait for the promise
            if ((angular.isObject(def) && angular.isObject(def.promise))) {
                delete $column.filterData;
                return def.promise.then(function(data) {
                    // our deferred can eventually return arrays, functions and objects
                    if (!angular.isArray(data) && !angular.isFunction(data) && !angular.isObject(data)) {
                        // if none of the above was found - we just want an empty array
                        data = [];
                    } else if (angular.isArray(data)) {
                        data.unshift({
                            title: '-',
                            id: ''
                        });
                    }
                    $column.data = data;
                });
            }
            // otherwise, we just return what the user gave us. It could be a function, array, object, whatever
            else {
                return $column.data = def;
            }
        });
    };

    this.buildColumns = function (columns) {
        return columns.map(function(col){
            return ngTableColumn.buildColumn(col, $scope)
        })
    };

    this.setupBindingsToInternalScope = function(tableParamsExpr){

        // note: this we're setting up watches to simulate angular's isolated scope bindings

        // note: is REALLY important to watch for a change to the ngTableParams *reference* rather than
        // $watch for value equivalence. This is because ngTableParams references the current page of data as
        // a field and it's important not to watch this
        var tableParamsGetter = $parse(tableParamsExpr);
        $scope.$watch(tableParamsGetter, (function (params) {
            if (angular.isUndefined(params)) {
                return;
            }
            $scope.paramsModel = tableParamsGetter;
            $scope.params = params;
        }), false);

        if ($attrs.showFilter) {
            $scope.$parent.$watch($attrs.showFilter, function(value) {
                $scope.show_filter = value;
            });
        }
        if ($attrs.disableFilter) {
            $scope.$parent.$watch($attrs.disableFilter, function(value) {
                $scope.$filterRow.disabled = value;
            });
        }
    };

    $scope.sortBy = function($column, event) {
        var parsedSortable = $column.sortable && $column.sortable();
        if (!parsedSortable) {
            return;
        }
        var defaultSort = $scope.params.settings().defaultSort;
        var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
        var sorting = $scope.params.sorting() && $scope.params.sorting()[parsedSortable] && ($scope.params.sorting()[parsedSortable] === defaultSort);
        var sortingParams = (event.ctrlKey || event.metaKey) ? $scope.params.sorting() : {};
        sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
        $scope.params.parameters({
            sorting: sortingParams
        });
    };
}]);


/**
 * @ngdoc service
 * @name ngTable.factory:ngTableColumn
 *
 * @description
 * Service to construct a $column definition used by {@link ngTable.directive:ngTable ngTable} directive
 */
app.factory('ngTableColumn', [function () {

    var defaults = {
        'class': function(){ return ''; },
        filter: function(){ return false; },
        filterData: angular.noop,
        headerTemplateURL: function(){ return false; },
        headerTitle: function(){ return ''; },
        sortable: function(){ return false; },
        show: function(){ return true; },
        title: function(){ return ''; },
        titleAlt: function(){ return ''; }
    };

    /**
     * @ngdoc method
     * @name ngTable.factory:ngTableColumn#buildColumn
     * @methodOf ngTable.factory:ngTableColumn
     * @description Creates a $column for use within a header template
     *
     * @param {Object} column an existing $column or simple column data object
     * @param {Scope} defaultScope the $scope to supply to the $column getter methods when not supplied by caller
     * @returns {Object} a $column object
     */
    function buildColumn(column, defaultScope){
        // note: we're not modifying the original column object. This helps to avoid unintended side affects
        var extendedCol = Object.create(column);
        for (var prop in defaults) {
            if (extendedCol[prop] === undefined) {
                extendedCol[prop] = defaults[prop];
            }
            if(!angular.isFunction(extendedCol[prop])){
                // wrap raw field values with "getter" functions
                // - this is to ensure consistency with how ngTable.compile builds columns
                // - note that the original column object is being "proxied"; this is important
                //   as it ensure that any changes to the original object will be returned by the "getter"
                (function(prop1){
                    extendedCol[prop1] = function(){
                        return column[prop1];
                    };
                })(prop);
            }
            (function(prop1){
                // satisfy the arguments expected by the function returned by parsedAttribute in the ngTable directive
                var getterFn = extendedCol[prop1];
                extendedCol[prop1] = function(){
                    if (arguments.length === 0){
                        return getterFn.call(column, defaultScope);
                    } else {
                        return getterFn.apply(column, arguments);
                    }
                };
            })(prop);
        }
        return extendedCol;
    }

    return {
        buildColumn: buildColumn
    };
}]);

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ngTable.directive:ngTable
 * @restrict A
 *
 * @description
 * Directive that instantiates {@link ngTable.directive:ngTable.ngTableController ngTableController}.
 */
app.directive('ngTable', ['$q', '$parse',
    function($q, $parse) {
        'use strict';

        return {
            restrict: 'A',
            priority: 1001,
            scope: true,
            controller: 'ngTableController',
            compile: function(element) {
                var columns = [],
                    i = 0,
                    row = null;

                // IE 8 fix :not(.ng-table-group) selector
                angular.forEach(angular.element(element.find('tr')), function(tr) {
                    tr = angular.element(tr);
                    if (!tr.hasClass('ng-table-group') && !row) {
                        row = tr;
                    }
                });
                if (!row) {
                    return;
                }
                angular.forEach(row.find('td'), function(item) {
                    var el = angular.element(item);
                    if (el.attr('ignore-cell') && 'true' === el.attr('ignore-cell')) {
                        return;
                    }

                    var getAttrValue = function(attr){
                        return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
                    };

                    var parsedAttribute = function(attr) {
                        var expr = getAttrValue(attr);
                        if (!expr){
                            return undefined;
                        }
                        return function(scope, locals) {
                            return $parse(expr)(scope, angular.extend(locals || {}, {
                                $columns: columns
                            }));
                        };
                    };

                    var titleExpr = getAttrValue('title-alt') || getAttrValue('title');
                    if (titleExpr){
                        el.attr('data-title-text', '{{' + titleExpr + '}}'); // this used in responsive table
                    }
                    // NOTE TO MAINTAINERS: if you add extra fields to a $column be sure to extend ngTableColumn with
                    // a corresponding "safe" default
                    columns.push({
                        id: i++,
                        title: parsedAttribute('title'),
                        titleAlt: parsedAttribute('title-alt'),
                        headerTitle: parsedAttribute('header-title'),
                        sortable: parsedAttribute('sortable'),
                        'class': parsedAttribute('header-class'),
                        filter: parsedAttribute('filter'),
                        headerTemplateURL: parsedAttribute('header'),
                        filterData: parsedAttribute('filter-data'),
                        show: (el.attr("ng-show") ? function (scope) {
                            return $parse(el.attr("ng-show"))(scope);
                        } : undefined)
                    });
                });
                return function(scope, element, attrs, controller) {
                    scope.$columns = columns = controller.buildColumns(columns);

                    controller.setupBindingsToInternalScope(attrs.ngTable);
                    controller.loadFilterData(columns);
                    controller.compileDirectiveTemplates();
                };
            }
        }
    }
]);

/**
 * @ngdoc directive
 * @name ngTable.directive:ngTableDynamic
 * @restrict A
 *
 * @description
 * A dynamic version of the {@link ngTable.directive:ngTable ngTable} directive that accepts a dynamic list of columns
 * definitions to render
 */
app.directive('ngTableDynamic', ['$parse', function ($parse){

    function parseDirectiveExpression(attr) {
        if (!attr || attr.indexOf(" with ") > -1) {
            var parts = attr.split(/\s+with\s+/);
            return {
                tableParams: parts[0],
                columns: parts[1]
            };
        } else {
            throw new Error('Parse error (expected example: ng-table-dynamic=\'tableParams with cols\')');
        }
    }

    return {
        restrict: 'A',
        priority: 1001,
        scope: true,
        controller: 'ngTableController',
        compile: function(tElement) {
            var row;

            // IE 8 fix :not(.ng-table-group) selector
            angular.forEach(angular.element(tElement.find('tr')), function(tr) {
                tr = angular.element(tr);
                if (!tr.hasClass('ng-table-group') && !row) {
                    row = tr;
                }
            });
            if (!row) {
                return;
            }

            angular.forEach(row.find('td'), function(item) {
                var el = angular.element(item);
                var getAttrValue = function(attr){
                    return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
                };

                // this used in responsive table
                var titleExpr = getAttrValue('title');
                if (!titleExpr){
                    el.attr('data-title-text', '{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}');
                }
                var showExpr = el.attr('ng-show');
                if (!showExpr){
                    el.attr('ng-show', '$columns[$index].show(this)');
                }
            });

            return function(scope, element, attrs, controller) {
                var expr = parseDirectiveExpression(attrs.ngTableDynamic);
                var columns = $parse(expr.columns)(scope) || [];
                scope.$columns = controller.buildColumns(columns);

                controller.setupBindingsToInternalScope(expr.tableParams);
                controller.loadFilterData(scope.$columns);
                controller.compileDirectiveTemplates();
            };
        }
    };
}]);

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ngTable.directive:ngTablePagination
 * @restrict A
 */
app.directive('ngTablePagination', ['$compile',
    function($compile) {
        'use strict';

        return {
            restrict: 'A',
            scope: {
                'params': '=ngTablePagination',
                'templateUrl': '='
            },
            replace: false,
            link: function(scope, element, attrs) {

                scope.params.settings().$scope.$on('ngTableAfterReloadData', function() {
                    scope.pages = scope.params.generatePagesArray(scope.params.page(), scope.params.total(), scope.params.count());
                }, true);

                scope.$watch('templateUrl', function(templateUrl) {
                    if (angular.isUndefined(templateUrl)) {
                        return;
                    }
                    var template = angular.element(document.createElement('div'))
                    template.attr({
                        'ng-include': 'templateUrl'
                    });
                    element.append(template);
                    $compile(template)(scope);
                });
            }
        };
    }
]);
angular.module('ngTable').run(['$templateCache', function ($templateCache) {
	$templateCache.put('ng-table/filters/select-multiple.html', '<select ng-options="data.id as data.title for data in $column.data" ng-disabled="$filterRow.disabled" multiple ng-multiple="true" ng-model="params.filter()[name]" ng-show="filter==\'select-multiple\'" class="filter filter-select-multiple form-control" name="{{name}}"> </select>');
	$templateCache.put('ng-table/filters/select.html', '<select ng-options="data.id as data.title for data in $column.data" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" ng-show="filter==\'select\'" class="filter filter-select form-control" name="{{name}}"> </select>');
	$templateCache.put('ng-table/filters/text.html', '<input type="text" name="{{name}}" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" ng-if="filter==\'text\'" class="input-filter form-control"/>');
	$templateCache.put('ng-table/header.html', '<tr> <th title="{{$column.headerTitle(this)}}" ng-repeat="$column in $columns" ng-class="{ \'sortable\': $column.sortable(this), \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\', \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\' }" ng-click="sortBy($column, $event)" ng-show="$column.show(this)" ng-init="template=$column.headerTemplateURL(this)" class="header {{$column.class(this)}}"> <div ng-if="!template" ng-show="!template" class="ng-table-header" ng-class="{\'sort-indicator\': params.settings().sortingIndicator==\'div\'}"> <span ng-bind="$column.title(this)" ng-class="{\'sort-indicator\': params.settings().sortingIndicator==\'span\'}"></span> </div> <div ng-if="template" ng-show="template" ng-include="template"></div> </th> </tr> <tr ng-show="show_filter" class="ng-table-filters"> <th data-title-text="{{$column.titleAlt(this) || $column.title(this)}}" ng-repeat="$column in $columns" ng-show="$column.show(this)" class="filter"> <div ng-repeat="(name, filter) in $column.filter(this)"> <div ng-if="filter.indexOf(\'/\') !==-1" ng-include="filter"></div> <div ng-if="filter.indexOf(\'/\')===-1" ng-include="\'ng-table/filters/\' + filter + \'.html\'"></div> </div> </th> </tr> ');
	$templateCache.put('ng-table/pager.html', '<div class="ng-cloak ng-table-pager" ng-if="params.data.length"> <div ng-if="params.settings().counts.length" class="ng-table-counts btn-group pull-right"> <button ng-repeat="count in params.settings().counts" type="button" ng-class="{\'active\':params.count()==count}" ng-click="params.count(count)" class="btn btn-default"> <span ng-bind="count"></span> </button> </div> <ul class="pagination ng-table-pagination"> <li ng-class="{\'disabled\': !page.active && !page.current, \'active\': page.current}" ng-repeat="page in pages" ng-switch="page.type"> <a ng-switch-when="prev" ng-click="params.page(page.number)" href="">&laquo;</a> <a ng-switch-when="first" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="page" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="more" ng-click="params.page(page.number)" href="">&#8230;</a> <a ng-switch-when="last" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="next" ng-click="params.page(page.number)" href="">&raquo;</a> </li> </ul> </div> ');
}]);
    return app;
}));

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UTableHeaderSortableDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_table_header_sortable_directive__ = __webpack_require__(127);



var UTableHeaderSortableDirective = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.components.u-table.header-sortable', []).directive('tableHeaderSortable', __WEBPACK_IMPORTED_MODULE_1__u_table_header_sortable_directive__["a" /* UTableHeaderSortableDirective */]);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UTableHeaderSortableDirective;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function UTableHeaderSortableDirective() {
  return {
    restrict: 'A',
    scope: {
      property: '@tableHeaderSortable',
      params: '=tableParams'
    },
    link: link
  };

  function link(scope, element) {
    var params = scope.params;
    if (!params) throw '\'table-params\' property must be be defined.';

    if (!params.hasOwnProperty('sorting')) throw '\'table-params\' property must be of type ngTableParam.';

    var property = scope.property;
    var sorting = params.sorting();

    // Always add `sortable` and `header` classes
    element.addClass('header sortable');

    // Add the sort class if column is the current sorting column
    if (Object.keys(sorting)[0] === property) element.addClass('sort-' + sorting[property]);

    // Watch the ngTableParams for sorting changes
    scope.$watch(function () {
      return params.sorting();
    }, removeSorting);

    // Handle click
    element.on('click', setSorting);

    function removeSorting(newVal) {
      var prop = Object.keys(newVal)[0];
      if (prop !== property) removeClasses();
    }

    function setSorting() {
      scope.$apply(function () {
        var sortOrder = params.isSortBy(property, 'asc') ? 'desc' : 'asc';
        params.sorting(_defineProperty({}, property, sortOrder));
        toggleSortClass(sortOrder);
        params.reload();
      });
    }

    function removeClasses() {
      element.removeClass('sort-asc sort-desc');
    }

    function toggleSortClass(order) {
      removeClasses();
      element.addClass('sort-' + order);
    }
  }
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UTableService;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_lang_isEmpty__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_lang_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_lang_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_table_utils__ = __webpack_require__(131);

UTableService.$inject = ['$rootScope', '$filter', '$log', '$q', 'ngTableParams'];




/**
 * ngTable options abstraction.
 */
function UTableService($rootScope, $filter, $log, $q, ngTableParams) {
  'ngInject';

  var _tables = {};
  var tableOpts = {};
  var orderBy = $filter('orderBy');

  var defaultOpts = {
    data: [],
    meta: {},
    sortOrder: {},
    showCounts: true,
    debug: false
  };

  var defaultParams = {
    page: 1,
    count: 10,
    sorting: {
      id: 'asc'
    }
  };

  function page(data, currentPage, count) {
    return data.slice((currentPage - 1) * count, currentPage * count);
  }

  function TableInstance(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.name = name;
    this.options = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.extend({}, defaultOpts, tableOpts, options);
    this.$ = '';
    this.search = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.extend({}, { filter: 'filter' }, this.options.search);
    this.selected = [];
    this.isDisabled = function () {};
    this.data = this.options.data || [];
    this.meta = this.options.meta || {};
    this.sortOrder = this.options.sortOrder || {};
    this.params = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.extend({}, defaultParams, this.options.params);
    this.tableParams = this.buildTableParams(this.options);
  }

  TableInstance.prototype.buildTableData = function (data, filter, params, callback) {
    if (filter) data = $filter(this.search.filter)(data, filter, this.search.properties);

    var orderedData = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.copy(data);
    if (params.sorting()) {
      orderedData = orderBy(orderedData, params.orderBy());
    }
    params.total(orderedData.length);
    return callback(page(orderedData, params.page(), params.count()));
  };

  TableInstance.prototype.buildTableParams = function (options) {
    var defaultSettings = {
      debugMode: this.options.debug,
      $scope: $rootScope.$new(),
      counts: [],
      total: this.data.length,
      getData: function (_this) {
        return function ($defer, params) {
          params.total(_this.data.length);
          return _this.buildTableData(_this.data, _this.$, params, function (data) {
            return $defer.resolve(data);
          });
        };
      }(this)
    };
    return new ngTableParams(this.params, __WEBPACK_IMPORTED_MODULE_1_angular___default.a.extend({}, defaultSettings, options));
  };

  TableInstance.prototype.filter = function () {
    this.tableParams.reload();
    if (this.tableParams.page() > 1) {
      this.tableParams.page(1);
    }
    return this;
  };

  TableInstance.prototype.hasData = function () {
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_lang_isEmpty___default()(this.data);
  };

  TableInstance.prototype.isSelected = function (data) {
    return this.selected.indexOf(data.id) > -1;
  };

  TableInstance.prototype.reload = function () {
    this.tableParams.reload();
    return this;
  };

  TableInstance.prototype.setCounts = function (counts) {
    var params = this.tableParams;

    if (this.options.showCounts) {
      params.settings().counts = counts || Object(__WEBPACK_IMPORTED_MODULE_2__u_table_utils__["a" /* getCounts */])(params.total());
    }
    return this;
  };

  TableInstance.prototype.setData = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    this.data = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.isArray(data) ? data : [data];
    if (this.data.length > 1) {
      this.setCounts();
    }
    this.filter();
    return this;
  };

  TableInstance.prototype.setIsDisabled = function (isDisabled) {
    this.isDisabled = isDisabled;
    return this;
  };

  TableInstance.prototype.setSelected = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var forceTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var self = this;
    data = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.isArray(data) ? data : [data];

    data.forEach(function (elem) {
      if (self.isDisabled(elem)) return;

      var idx = self.selected.indexOf(elem.id);
      if (idx == -1) {
        if (forceTo !== false) self.selected.push(elem.id);
      } else {
        if (forceTo !== true) self.selected.splice(idx, 1);
      }
    });

    return this;
  };

  TableInstance.prototype.selectCurrentPage = function () {
    this.setSelected(this.tableParams.data, !this.isCurrentPageSelected());
  };

  TableInstance.prototype.isCurrentPageSelected = function () {
    var _this2 = this;

    return this.hasSelectableElements() && this.tableParams.data.filter(function (elem) {
      return !_this2.isDisabled(elem);
    }).every(function (elem) {
      return _this2.selected.indexOf(elem.id) !== -1;
    });
  };

  TableInstance.prototype.hasSelectableElements = function () {
    var _this3 = this;

    return this.tableParams.data.some(function (elem) {
      return !_this3.isDisabled(elem);
    });
  };

  TableInstance.prototype.selectAll = function () {
    var self = this;
    return this.data.map(function (elem) {
      if (self.isDisabled(elem)) return;
      return elem.id;
    }).filter(function (elem) {
      return !!elem;
    });
  };

  TableInstance.prototype.setSorting = function (key) {
    var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var currentSorting = void 0,
        defaultOrder = void 0,
        orders = void 0,
        sortOrder = void 0,
        sorting = void 0;
    orders = ['asc', 'desc'];
    sorting = {};
    currentSorting = this.tableParams.sorting();
    defaultOrder = this.sortOrder[key] || 'asc';
    sortOrder = currentSorting[key] && !init ? orders[+!orders.indexOf(currentSorting[key])] : defaultOrder;
    sorting[key] = sortOrder;
    this.tableParams.sorting(sorting);
    return this;
  };

  TableInstance.prototype.getCurrentPageData = function () {
    return this.table.tableParams.data;
  };

  var self = {
    /**
     * Get a specific table
     * @param  {String} name The table name to get
     * @return {Object}      The table
     */
    get: function (name) {
      return _tables[name];
    },

    /**
     * Set table options which apply across all tables
     * @param  {Object} options The table options
     * @return {Object}         The Table service for chainability
     */
    options: function (options) {
      __WEBPACK_IMPORTED_MODULE_1_angular___default.a.extend(tableOpts, options);
      return self;
    },

    /**
     * Create a new table
     * @param  {String} name    The table name
     * @param  {Object} options The table options
     * @return {Object}         The Table service for chainability
     */
    new: function (name, options) {
      _tables[name] = new TableInstance(name, options);
      return _tables[name];
    },

    /**
     * Get all the tables
     * @return {Array} An array of table objects
     */
    tables: function () {
      return _tables;
    }
  };

  return self;
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(13),
    isArray = __webpack_require__(5),
    isArrayLike = __webpack_require__(6),
    isFunction = __webpack_require__(20),
    isObjectLike = __webpack_require__(3),
    isString = __webpack_require__(130),
    keys = __webpack_require__(11);

/**
 * Checks if `value` is empty. A value is considered empty unless it's an
 * `arguments` object, array, string, or jQuery-like collection with a length
 * greater than `0` or an object with own enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {Array|Object|string} value The value to inspect.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
      (isObjectLike(value) && isFunction(value.splice)))) {
    return !value.length;
  }
  return !keys(value).length;
}

module.exports = isEmpty;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var isObjectLike = __webpack_require__(3);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_table_utils__ = __webpack_require__(132);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__u_table_utils__["a"]; });


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCounts;
var DEFAULT_PAGE_COUNTS = [10, 25, 50, 100, 250];

function getCounts(total) {
  // Be smart about the counts options that we show, if the total data length isn't
  // more than the specific count, there isn't any point in showing it as an option.
  return DEFAULT_PAGE_COUNTS.sort(sort).map(map).filter(function (count) {
    return !!count;
  });

  function sort(a, b) {
    return a - b;
  }

  function map(count, idx, array) {
    var prevCount = idx < 1 ? count : array[idx - 1];
    return total > prevCount ? count : null;
  }
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(134);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-table.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-table.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".ng-table th {\n  text-align: center;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ng-table th.sortable {\n  cursor: pointer;\n}\n.ng-table th.sortable .sort-indicator {\n  padding-right: 18px;\n  position: relative;\n}\n.ng-table th.sortable .sort-indicator:after, .ng-table th.sortable .sort-indicator:before {\n  content: \"\";\n  border-width: 0 4px 4px;\n  border-style: solid;\n  border-color: #000 transparent;\n  visibility: visible;\n  right: 5px;\n  top: 50%;\n  position: absolute;\n  opacity: .3;\n  margin-top: -4px;\n}\n.ng-table th.sortable .sort-indicator:before {\n  margin-top: 2px;\n  border-bottom: none;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid #000;\n}\n.ng-table th.sortable .sort-indicator:hover:after, .ng-table th.sortable .sort-indicator:hover:before {\n  opacity: 1;\n  visibility: visible;\n}\n.ng-table th.sortable.sort-desc, .ng-table th.sortable.sort-asc {\n  background-color: rgba(141, 192, 219, .25);\n  text-shadow: 0 1px 1px rgba(255, 255, 255, .75);\n}\n.ng-table th.sortable.sort-desc .sort-indicator:after, .ng-table th.sortable.sort-asc .sort-indicator:after {\n  margin-top: -2px;\n}\n.ng-table th.sortable.sort-desc .sort-indicator:before, .ng-table th.sortable.sort-asc .sort-indicator:before {\n  visibility: hidden;\n}\n.ng-table th.sortable.sort-asc .sort-indicator:after, .ng-table th.sortable.sort-asc .sort-indicator:hover:after {\n  visibility: visible;\n  filter: alpha(opacity=60);\n  -khtml-opacity: 0.6;\n  -moz-opacity: 0.6;\n  opacity: 0.6;\n}\n.ng-table th.sortable.sort-desc .sort-indicator:after {\n  border-bottom: none;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid #000;\n  visibility: visible;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  filter: alpha(opacity=60);\n  -khtml-opacity: 0.6;\n  -moz-opacity: 0.6;\n  opacity: 0.6;\n}\n.ng-table th.filter .input-filter {\n  margin: 0;\n  display: block;\n  width: 100%;\n  min-height: 30px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.ng-table + .pagination {\n  margin-top: 0;\n}\n@media only screen and (max-width: 800px) {\n  .ng-table-responsive {\n    border-bottom: 1px solid #999999;\n  }\n  .ng-table-responsive tr {\n    border-top: 1px solid #999999;\n    border-left: 1px solid #999999;\n    border-right: 1px solid #999999;\n  }\n  .ng-table-responsive td:before {\n    position: absolute;\n    padding: 8px;\n    left: 0;\n    top: 0;\n    width: 50%;\n    white-space: nowrap;\n    text-align: left;\n    font-weight: bold;\n  }\n  .ng-table-responsive thead tr th {\n    text-align: left;\n  }\n  .ng-table-responsive thead tr.ng-table-filters th {\n    padding: 0;\n  }\n  .ng-table-responsive thead tr.ng-table-filters th form > div {\n    padding: 8px;\n  }\n  .ng-table-responsive td {\n    border: none;\n    border-bottom: 1px solid #eeeeee;\n    position: relative;\n    padding-left: 50%;\n    white-space: normal;\n    text-align: left;\n  }\n  .ng-table-responsive td:before {\n    content: attr(data-title-text);\n  }\n  .ng-table-responsive, .ng-table-responsive thead, .ng-table-responsive tbody, .ng-table-responsive th, .ng-table-responsive td, .ng-table-responsive tr {\n    display: block;\n  }\n}\n.table th {\n  white-space: nowrap;\n}\n/* Extend bootstrap's responsive table to always (not just mobile) scroll content that's too long. */\n.table-responsive {\n  overflow-x: auto;\n}\n/* Needed to hide the hidden pagination template which shouldn't be rendered in the first place.\n   @ref https://github.com/esvit/ng-table/issues/6 */\n.ng-table-pager {\n  display: none;\n}\n", ""]);

// exports


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UToastDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_toast_directive__ = __webpack_require__(136);



var UToastDirective = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-toast.directive', []).directive('uToast', __WEBPACK_IMPORTED_MODULE_1__u_toast_directive__["a" /* UToastDirective */]);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UToastDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_toast_directive_html__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_toast_directive_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__u_toast_directive_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_toast_constants__ = __webpack_require__(24);
UToastDirective.$inject = ['$compile', '$animate', '$interval'];



var DEFAULT_DELAY = 5000;

function UToastDirective($compile, $animate, $interval) {
  'ngInject';

  return {
    restrict: 'E',
    link: link
  };

  function link(scope, element, attrs) {
    var delay = attrs.delay || DEFAULT_DELAY;

    scope.$on(__WEBPACK_IMPORTED_MODULE_1__u_toast_constants__["a" /* SHOW_TOAST_EVENT */], function (event, locals) {
      return enter(locals);
    });

    function enter(toastScope) {
      var classes = attrs.classes ? [toastScope.classes, attrs.classes].join(' ') : toastScope.classes;

      // Create and setup the new isolate scope
      var newScope = scope.$new(true);
      newScope.toast = toastScope;
      var toastEl = $compile(__WEBPACK_IMPORTED_MODULE_0__u_toast_directive_html___default.a)(newScope);
      newScope.close = leave(toastEl);

      // Was using ng-class but that doesn't work, so have to add classes
      // here so that ngAnimate will add the ng-enter class when
      // using classNameFilter.
      toastEl.addClass(classes);

      // Append the toast to the last toast
      $animate.enter(toastEl, element, getLastToast());

      $interval(newScope.close, delay, 1);
    }

    function leave(el) {
      return function () {
        $animate.leave(el);
      };
    }

    function getLastToast() {
      var toasts = element[0].querySelectorAll('ut-toast-content');
      return toasts[toasts.length - 1];
    }
  }
}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = "<ut-toast-content>\n  <u-fa-icon success-icon name=\"check-circle\"></u-fa-icon>\n  <u-fa-icon error-icon name=\"exclamation-circle\"></u-fa-icon>\n\n  <ut-toast-message>{{toast.message}}</ut-toast-message>\n\n  <ut-toast-controls>\n    <button ng-click=\"close()\">×</button>\n  </ut-toast-controls>\n</ut-toast-content>\n"

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UToastService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_toast_service__ = __webpack_require__(139);



var UToastService = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-toast.service', []).service('uToast', __WEBPACK_IMPORTED_MODULE_1__u_toast_service__["a" /* UToastService */]);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UToastService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__u_toast_constants__ = __webpack_require__(24);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var UToastService = function () {
  UToastService.$inject = ['$rootScope', '$timeout'];

  function UToastService($rootScope, $timeout) {
    'ngInject';

    _classCallCheck(this, UToastService);

    Object.assign(this, { $rootScope: $rootScope, $timeout: $timeout });
  }

  _createClass(UToastService, [{
    key: 'success',
    value: function success(message) {
      var locals = {
        message: message,
        classes: 'success',
        icon: 'check'
      };

      this._show(locals);
    }
  }, {
    key: 'error',
    value: function error(message) {
      var locals = {
        message: message,
        classes: 'error',
        icon: 'error'
      };

      this._show(locals);
    }
  }, {
    key: '_show',
    value: function _show(locals) {
      var _this = this;

      // Wait for the next digest cycle, otherwise the directive might not
      // have been initialed yet.  This allows the toaster to be used in
      // things like uiRouter's onEnter function within states.
      this.$timeout(function () {
        _this.$rootScope.$broadcast(__WEBPACK_IMPORTED_MODULE_0__u_toast_constants__["a" /* SHOW_TOAST_EVENT */], locals);
      });
    }
  }]);

  return UToastService;
}();

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(141);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-toast.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-toast.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "/* Breakpoint values taken from our original bootstrap setup:\n  xs: 480px\n  sm: 768px\n  md: 992px\n  lg: 1200px\n*/\n/*\n  Used to declare these as variables, but no longer works:\n  https://github.com/MoOx/postcss-cssnext/issues/262;\n*/\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\nu-toast ut-toast-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 15px 0;\n  margin: 5px;\n  border: 1px solid;\n  border-radius: 4px;\n  line-height: 1\n}\nu-toast ut-toast-content.ng-enter {\n  -webkit-animation: fadeIn 0.5s cubic-bezier(0.55, 0, 0.55, 0.2);\n          animation: fadeIn 0.5s cubic-bezier(0.55, 0, 0.55, 0.2);\n}\nu-toast ut-toast-content.ng-leave {\n  -webkit-animation: fadeOut 0.5s cubic-bezier(0.55, 0, 0.55, 0.2);\n          animation: fadeOut 0.5s cubic-bezier(0.55, 0, 0.55, 0.2);\n}\nu-toast u-fa-icon {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  margin: 0 10px;\n  font-size: 26px\n}\nu-toast ut-toast-message {\n  margin-right: auto;\n  line-height: 1.8\n}\nu-toast .success {\n  border-color: #75c79b;\n  color: #3c763d;\n  background-color: #e3f4eb;\n}\nu-toast .success [error-icon] {\n  display: none;\n}\nu-toast .error {\n  border-color: #fcb8bc;\n  color: #a94442;\n  background-color: #fee8e9;\n}\nu-toast .error [success-icon] {\n  display: none;\n}\nu-toast ut-toast-controls {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n  margin: 0 10px;\n}\nu-toast ut-toast-controls button {\n  background: transparent;\n  border: 0;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 1;\n  text-shadow: 0 1px 0 #ffffff;\n  opacity: 0.2\n}\nu-toast ut-toast-controls button:hover {\n  opacity: 0.5;\n}\n@media (min-width: 768px) {\n  u-toast ut-toast-content {\n    max-width: 400px;\n  }\n    }\n@media (min-width: 992px) {\n  u-toast u-fa-icon {\n    margin-right: 15px;\n  }\n    }\n@media (max-width: 767px) {\n  u-toast ut-toast-message {\n    font-size: 12px;\n  }\n    }\n@media (min-width: 768px) and (max-width: 991px) {\n  u-toast ut-toast-message {\n    font-size: 14px;\n  }\n    }\n@media (min-width: 992px) {\n  u-toast ut-toast-message {\n    font-size: 16px;\n  }\n    }\n@media (gt-sm) {\n  u-toast ut-toast-controls {\n    margin-left: 20px;\n  }\n    }\n", ""]);

// exports


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return globals; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__urls_json__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__urls_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__urls_json__);


var globals = {
  urls: __WEBPACK_IMPORTED_MODULE_0__urls_json___default.a
};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = {"cdn":"//d30c45h9cuv4p4.cloudfront.net","cdnFonts":"//d30c45h9cuv4p4.cloudfront.net/fonts"}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bind_compile__ = __webpack_require__(145);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__bind_compile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(147);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_loading__ = __webpack_require__(149);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__u_loading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loading_overlay__ = __webpack_require__(154);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__loading_overlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__u_notify__ = __webpack_require__(160);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__u_notify__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__u_notify__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__u_redirect__ = __webpack_require__(163);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__u_redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__u_change__ = __webpack_require__(165);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__u_change__["a"]; });








/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BindCompileHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bind_compile_directive__ = __webpack_require__(146);



var BindCompileHelper = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.helpers.bind-compile', []).directive('uBindCompile', __WEBPACK_IMPORTED_MODULE_1__bind_compile_directive__["a" /* BindCompileDirective */]);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BindCompileDirective;
BindCompileDirective.$inject = ['$compile'];
function BindCompileDirective($compile) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      content: '=uBindCompile'
    },
    link: link
  };

  function link(scope, element) {
    function compile(content) {
      element.html(content);
      $compile(element.contents())(scope.$parent);
    }

    var watch = function () {
      return scope.content;
    };
    scope.$watch(watch, compile);
  }
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutsideModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside_directive__ = __webpack_require__(148);



var ClickOutsideModule = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.helpers.click-outside', []).directive('updClickOutside', __WEBPACK_IMPORTED_MODULE_1__click_outside_directive__["a" /* ClickOutsideDirective */]);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ClickOutsideDirective;
ClickOutsideDirective.$inject = ['$document', '$timeout'];
function ClickOutsideDirective($document, $timeout) {
  'ngInject';

  return {
    restrict: 'A',
    link: link,
    scope: {
      onClickedOutside: '&updClickOutside'
    }
  };

  function link(scope, element) {
    $document.on('click', onClick);
    scope.$on('$destroy', function () {
      return $document.off('click', onClick);
    });

    function onClick(event) {
      var target = event.target;

      var domElement = element[0];
      // If the target is not the host element or within the host
      // element, then we can assume it's outside of the host element
      if (target !== domElement && !domElement.contains(target)) {
        // $timeout to ensure the expression is invoked within
        // the AngularJS context.
        $timeout(scope.onClickedOutside());
      }
    }
  }
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ULoadingHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_loading_directive__ = __webpack_require__(150);



var ULoadingHelper = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.helpers.u-loading', []).directive('uLoading', __WEBPACK_IMPORTED_MODULE_1__u_loading_directive__["a" /* ULoadingDirective */]);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ULoadingDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_loading_html__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_loading_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__u_loading_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_loading_global_css__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_loading_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__u_loading_global_css__);
ULoadingDirective.$inject = ['$compile', '$animate'];




var U_LOADING_TEMPLATE = '<u-loading-template></u-loading-template>';

// Adds a loader within the element content when the `u-loading` attribute is true.
//
//  Usage:
//
//    Basic:
//
//      <div u-loading="isLoading">
//        <span> This is the content
//      </div>
//
//    Set a message:
//
//      <div u-loading="isLoading" u-loading-message="We are loading...">
//        <span> This is the content
//      </div>
//
//     Set a custom template:
//
//      <div u-loading="isLoading" u-loading-template="{{template}}">
//        <span> This is the content
//      </div>
//
//  When isLoading is true, the content within the div will be replaced with
//  what the template property points at (by default, Angular Material's
//  indeterminate circular progress indicator).
//
function ULoadingDirective($compile, $animate) {
  'ngInject';

  return {
    transclude: true,
    // Ensure this runs after all other directives
    // and is the last directive to run
    priority: -9999,
    terminal: true,
    scope: {
      loading: '=uLoading',
      message: '@uLoadingMessage'
    },
    link: link
  };

  function link(scope, element, attrs, ctrl, transclude) {
    var block = void 0,
        childScope = void 0,
        previousElements = void 0;

    // Build the loading template
    var loadingTemplateWrapper = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(U_LOADING_TEMPLATE);
    var loadingTemplateEl = $compile(attrs.uLoadingTemplate || __WEBPACK_IMPORTED_MODULE_1__u_loading_html___default.a)(scope);
    loadingTemplateWrapper.append(loadingTemplateEl);

    scope.$watch('loading', onLoadingChange);

    // Mimics angular ngIf, but in reverse and implementing the loading template logic
    // REF: https://github.com/angular/angular.js/blob/master/src/ng/directive/ngIf.js
    function onLoadingChange(value) {
      if (value) {
        $animate.enter(loadingTemplateWrapper, element);
        hideContent();
      } else {
        $animate.leave(loadingTemplateWrapper);
        showContent();
      }
    }

    function hideContent() {
      if (previousElements) {
        previousElements.remove();
        previousElements = null;
      }
      if (childScope) {
        childScope.$destroy();
        childScope = null;
      }
      if (block) {
        previousElements = getBlockNodes(block.clone);
        $animate.leave(previousElements).then(function () {
          previousElements = null;
        });
        block = null;
      }
    }

    function showContent() {
      if (!childScope) {
        transclude(function (clone, newScope) {
          childScope = newScope;
          block = { clone: clone };
          $animate.enter(clone, element);
        });
      }
    }
  }

  // Return the DOM siblings between the first and last node in the given array.
  // Taken from angular core since Angular does not expose it
  // REF: https://github.com/angular/angular.js/blob/4daafd3dbe6a80d578f5a31df1bb99c77559543e/src/Angular.js#L1799
  function getBlockNodes(nodes) {
    var node = nodes[0];
    var endNode = nodes[nodes.length - 1];
    var blockNodes = void 0;

    for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
      if (blockNodes || nodes[i] !== node) {
        if (!blockNodes) {
          blockNodes = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element([].slice.call(nodes, 0, i));
        }
        blockNodes.push(node);
      }
    }

    return blockNodes || nodes;
  }
}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-loading-default-template\">\n  <div class=\"u-loading-default-message\" ng-if=\"message\">{{::message}}</div>\n  <upd-loading-spinner></upd-loading-spinner>\n</div>\n"

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(153);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-loading.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./u-loading.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "u-loading-template .u-loading-default-template {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: column;\n            flex-flow: column;\n    font-size: 6em;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\nu-loading-template .u-loading-default-message {\n    font-size: 0.167em;\n    line-height: 2;\n    text-transform: uppercase;\n    color: #666667;\n}\n", ""]);

// exports


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading_overlay_module__ = __webpack_require__(155);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__loading_overlay_module__["a"]; });


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingOverlayModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading_overlay_directive__ = __webpack_require__(156);



var LoadingOverlayModule = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.helpers.loading-overlay', []).directive('updLoadingOverlay', __WEBPACK_IMPORTED_MODULE_1__loading_overlay_directive__["a" /* LoadingOverlayDirective */]);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LoadingOverlayDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading_overlay_html__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading_overlay_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loading_overlay_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading_overlay_global_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading_overlay_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loading_overlay_global_css__);
LoadingOverlayDirective.$inject = ['$compile', '$animate'];




var WRAPPER_TEMPLATE = '<upd-loading-overlay-wrapper></upd-loading-overlay-wrapper>';

function LoadingOverlayDirective($compile, $animate) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      loading: '=updLoadingOverlay'
    },
    link: link
  };

  function link(scope, element) {
    var loadingTemplateWrapper = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(WRAPPER_TEMPLATE);
    var loadingTemplateEl = $compile(__WEBPACK_IMPORTED_MODULE_1__loading_overlay_html___default.a)(scope);

    scope.$watch('loading', onLoadingChange);

    function onLoadingChange(value) {
      if (value) {
        element.append(loadingTemplateWrapper);
        $animate.enter(loadingTemplateEl, loadingTemplateWrapper);
      } else {
        $animate.leave(loadingTemplateEl).then(function () {
          return loadingTemplateWrapper.remove();
        });
      }
    }
  }
}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = "<upd-loading-overlay-template class=\"u-animate\">\n  <upd-loading-spinner></upd-loading-spinner>\n</upd-loading-overlay-template>\n"

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(159);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./loading-overlay.global.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js!./loading-overlay.global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "[upd-loading-overlay] {\n  position: relative;\n}\n\nupd-loading-overlay-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n\nupd-loading-overlay-template {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  background-color: rgba(0, 0, 0, .1);\n}\n\nupd-loading-overlay-template upd-loading-spinner {\n  font-size: 6em;\n}\n\nupd-loading-overlay-template.ng-enter, upd-loading-overlay-template.ng-leave {\n  -webkit-transition: opacity ease-in-out 0.3s;\n  transition: opacity ease-in-out 0.3s;\n}\n\nupd-loading-overlay-template.ng-enter, upd-loading-overlay-template.ng-leave.ng-leave-active {\n  opacity: 0;\n}\n\nupd-loading-overlay-template.ng-leave, upd-loading-overlay-template.ng-enter.ng-enter-active {\n  opacity: 1;\n}\n", ""]);

// exports


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNotifyHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_error_codes_json__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_error_codes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__u_error_codes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_notify_service__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_u_toast__ = __webpack_require__(23);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__u_error_codes_json___default.a; });







var UNotifyHelper = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.helpers.u-notify', [__WEBPACK_IMPORTED_MODULE_3__components_u_toast__["a" /* UToastComponent */].name]).constant('uErrorCodes', __WEBPACK_IMPORTED_MODULE_1__u_error_codes_json___default.a).service('uNotify', __WEBPACK_IMPORTED_MODULE_2__u_notify_service__["a" /* UNotifyService */]);

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = {"ACTION_NOT_FOUND":null,"BAD_REQUEST":null,"FROM_ADDRESS_IS_COMMERCIAL":null,"INVALID_AUTHENTICITY_TOKEN":null,"INVALID_CROSS_ORIGIN_REQUEST":null,"INVITE_CLAIMED":"Looks like this person already accepted this invite and started using Updater.","LISTING_DATE_ONLY":"Looks like you've only provided a listing date. We need an estimated move date, contract date, or close date to send an invite.","METHOD_NOT_ALLOWED":null,"MOVE_CONFIRMED":"Looks like this person is already using Updater for this move.","MOVER_FIRST_NAME_HAS_NUMBER":"Oops! Looks like the first name you provided contains a numeric value. Please use only alphabetic values.","MOVER_FIRST_NAME_IS_A_COMPANY":"Oops! Looks like the first name you provided is a business name. Please enter a valid first name to continue.","MOVER_LAST_NAME_HAS_NUMBER":"Oops! Looks like the last name you provided contains a numeric value. Please use only alphabetic values.","MOVER_LAST_NAME_IS_A_COMPANY":"Oops! Looks like the last name you provided is a business name. Please enter a valid last name to continue.","MOVER_MIDDLE_NAME_IS_A_COMPANY":"Oops! Looks like the middle initial you provided is a business name. Please provide a valid middle initial to continue.","NOT_IMPLEMENTED":null,"PARAMETER_MISSING":null,"PARSE_ERROR":null,"RECORD_INVALID":null,"RECORD_NOT_FOUND":null,"RECORD_NOT_SAVED":null,"REDIRECT":null,"ROUTING_ERROR":null,"SAME_MOVER_AGENT_EMAILS":"Looks like you've entered your own email address. Please enter your client's email address to continue.","STALE_OBJECT_ERROR":null,"TO_ADDRESS_IS_COMMERCIAL":null,"UNCLAIMED_AGENT":"Looks like you haven't claimed your Updater account yet. Check your inbox for your personalized invite!","UNKNOWN_FORMAT":null,"UNKNOWN_HTTP_METHOD":null,"UNSUPPORTED_MIMETYPE":null,"USER_CLAIMED":"Looks like that email address is associated with an existing Updater user.","USER_DELETED":null,"USER_UNSUBSCRIBED":"Looks like this person has unsubscribed from Updater. Ask them to reach out to success@updater.com to resubscribe.","ZIP_TOO_SHORT":null}

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNotifyService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_ERROR_MSG = 'Oops! Looks like something went wrong.';
var ERROR_CODE_PROPERTY = 'code';
// TODO: Remove when v1 is no more!
var ERROR_CODE_PROPERTY_V1 = 'error_code';

var UNotifyService = function () {
  UNotifyService.$inject = ['uToast', 'uErrorCodes'];

  function UNotifyService(uToast, uErrorCodes) {
    'ngInject';

    _classCallCheck(this, UNotifyService);

    this._toast = uToast;
    this._errorCodes = uErrorCodes;
  }

  /**
   * Display a success message via uToast
   * @param  {String} message The message to display
   */


  _createClass(UNotifyService, [{
    key: 'success',
    value: function success(message) {
      this._toast.success(message);
    }

    /**
     * Displays an error message via uToast based on the API response
     * @param  {Object} error The API error object
     */

  }, {
    key: 'error',
    value: function error() {
      var _error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // Account for v1 `error_code`... v2 uses `code`
      // TODO: Remove (error[ERROR_CODE_PROPERTY_V1] ||) when v1 is no more!
      var code = _error[ERROR_CODE_PROPERTY_V1] || _error[ERROR_CODE_PROPERTY];

      // Will use the error code from the API first if it's defined in the uErrorCodes
      // otherwise, it will use the error message from the API
      //    - we do this since all of our top-level error messages should always
      //      be human readable for an API consumer
      // otherwise, use the default error message.
      var msg = this._errorCodes[code] || _error.message || DEFAULT_ERROR_MSG;

      this._toast.error(msg);
    }
  }]);

  return UNotifyService;
}();



/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return URedirectHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_redirect_service__ = __webpack_require__(164);



var URedirectHelper = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.u-redirect', []).service('URedirect', __WEBPACK_IMPORTED_MODULE_1__u_redirect_service__["a" /* URedirectService */]);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return URedirectService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Used for performing a hard redirect
//
// Example: 418 Redirect (user is on the wrong subdomain)
var URedirectService = function () {
  URedirectService.$inject = ['$window', '$httpParamSerializer'];

  function URedirectService($window, $httpParamSerializer) {
    'ngInject';

    _classCallCheck(this, URedirectService);

    this.window = $window;
    this.serializer = $httpParamSerializer;
  }

  _createClass(URedirectService, [{
    key: '_buildUrl',
    value: function _buildUrl(baseUrl, path) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var url = baseUrl;
      var qsParams = this.serializer(params);

      if (path) {
        url += '/' + path;
      }

      // Add querystring parameters if any are defined
      if (qsParams.length) {
        url += '?' + qsParams;
      }

      // Strip any duplicate forward slashes
      return url.replace(/([^:]\/)\/+/g, '$1');
    }
  }, {
    key: 'go',
    value: function go(baseUrl, path, params) {
      var url = this._buildUrl(baseUrl, path, params);
      this.window.location.href = url;
    }
  }]);

  return URedirectService;
}();

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__u_change_directive__ = __webpack_require__(166);



var ChangeModule = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('app.directives.change', []).directive('updChange', __WEBPACK_IMPORTED_MODULE_1__u_change_directive__["a" /* Change */]);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Change;
Change.$inject = ['$parse'];
function Change($parse) {
  'ngInject';

  return {
    restrict: 'A',
    compile: function (element, attr) {
      var fn = $parse(attr.updChange);
      return function (scope, element) {
        element.on('change', function (e) {
          scope.$apply(function () {
            fn(scope, { $event: e });
          });
        });
      };
    }
  };
}

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors_json__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__colors_json__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__colors_json___default.a; });




/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = {"blue-darker":"#2b7499","blue-dark":"#5590ad","blue-mid":"#80acc2","blue-light":"#aac7d6","blue-lighter":"#d5e3eb","blue-lightest":"#f3fcff","blue-highlight":"#3692c1","green-darker":"#56b784","green-dark":"#75c79b","green-mid":"#92d7b2","green-light":"#b1e7c9","green-lighter":"#e3f4eb","green-lightest":"#f4fbf7","green-highlight":"#58c469","red-darker":"#f84e57","red-dark":"#f97179","red-mid":"#fb959a","red-light":"#fcb8bc","red-lighter":"#fee8e9","yellow-darker":"#ffe98f","yellow-dark":"#ffefad","yellow-mid":"#fff7db","yellow-light":"#fffcec","yellow-lighter":"#fffdf5","orange-mid":"#f6936b","black":"#000000","white":"#ffffff","neutral-darker":"#404041","neutral-dark":"#666667","neutral-mid":"#8c8c8d","neutral-light":"#bababb","neutral-lighter":"#e4e4e5","neutral-lightest":"#efefef","neutral-lighterest":"#f5f5f5","brand-primary":"$blue-darker","brand-success":"$green-darker","brand-info":"$yellow-dark","brand-warning":"$orange-mid","brand-danger":"$red-dark"}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__address__ = __webpack_require__(170);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__address__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__address__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__address__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__address__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__centered_range__ = __webpack_require__(183);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__centered_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mod__ = __webpack_require__(186);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__mod__["a"]; });




/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format__ = __webpack_require__(171);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalize__ = __webpack_require__(28);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__normalize__["a"]; });



/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatAddress;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatUnnormalizedAddress; });
/* harmony export (immutable) */ __webpack_exports__["c"] = formatZip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_function_compose__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_function_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_function_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalize__ = __webpack_require__(28);




function formatAddress(address) {
  address = address || {};

  return [address.address1, address.address2, address.address3, address.address4, address.city].filter(Boolean).concat([address.state, formatZip(address.zip)].filter(Boolean).join(' ')).join(', ');
}

var formatUnnormalizedAddress = __WEBPACK_IMPORTED_MODULE_0_lodash_function_compose___default()(formatAddress, __WEBPACK_IMPORTED_MODULE_1__normalize__["a" /* normalizeAddress */]);

function formatZip(value) {
  value = parseInt(value, 10).toString();

  if (value === 'NaN') {
    return '';
  } else if (value.length > 5) {
    return value.substr(0, 5) + '-' + value.substr(5, 4);
  } else {
    return value;
  }
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(173);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(174);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the provided functions from right to left.
 *
 * @static
 * @memberOf _
 * @alias backflow, compose
 * @category Function
 * @param {...Function} [funcs] Functions to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight(square, _.add);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(14),
    getData = __webpack_require__(26),
    getFuncName = __webpack_require__(27),
    isArray = __webpack_require__(5),
    isLaziable = __webpack_require__(179);

/** Used to compose bitmasks for wrapper metadata. */
var CURRY_FLAG = 8,
    PARTIAL_FLAG = 32,
    ARY_FLAG = 128,
    REARG_FLAG = 256;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return function() {
    var wrapper,
        length = arguments.length,
        index = fromRight ? length : -1,
        leftIndex = 0,
        funcs = Array(length);

    while ((fromRight ? index-- : ++index < length)) {
      var func = funcs[leftIndex++] = arguments[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
        wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? -1 : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  };
}

module.exports = createFlow;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var getNative = __webpack_require__(12);

/** Native method references. */
var WeakMap = getNative(global, 'WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(176)))

/***/ }),
/* 176 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(16),
    getData = __webpack_require__(26),
    getFuncName = __webpack_require__(27),
    lodash = __webpack_require__(180);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(16),
    LodashWrapper = __webpack_require__(14),
    baseLodash = __webpack_require__(15),
    isArray = __webpack_require__(5),
    isObjectLike = __webpack_require__(3),
    wrapperClone = __webpack_require__(181);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit chaining.
 * Methods that operate on and return arrays, collections, and functions can
 * be chained together. Methods that retrieve a single value or may return a
 * primitive value will automatically end the chain returning the unwrapped
 * value. Explicit chaining may be enabled using `_.chain`. The execution of
 * chained methods is lazy, that is, execution is deferred until `_#value`
 * is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
 * fusion is an optimization strategy which merge iteratee calls; this can help
 * to avoid the creation of intermediate data structures and greatly reduce the
 * number of iteratee executions.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
 * `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
 * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
 * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
 * and `where`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
 * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
 * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
 * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
 * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
 * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
 * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
 * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
 * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
 * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
 * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
 * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
 * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
 * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
 * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
 * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
 * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
 * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
 * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
 * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
 * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
 * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
 * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
 * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
 * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
 * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
 * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
 * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
 * `unescape`, `uniqueId`, `value`, and `words`
 *
 * The wrapper method `sample` will return a wrapped value when `n` is provided,
 * otherwise an unwrapped value is returned.
 *
 * @name _
 * @constructor
 * @category Chain
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // returns an unwrapped value
 * wrapped.reduce(function(total, n) {
 *   return total + n;
 * });
 * // => 6
 *
 * // returns a wrapped value
 * var squares = wrapped.map(function(n) {
 *   return n * n;
 * });
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;

module.exports = lodash;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(16),
    LodashWrapper = __webpack_require__(14),
    arrayCopy = __webpack_require__(182);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  return wrapper instanceof LazyWrapper
    ? wrapper.clone()
    : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
}

module.exports = wrapperClone;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function arrayCopy(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = arrayCopy;


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__centered_range_util__ = __webpack_require__(184);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__centered_range_util__["a"]; });


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = centeredRange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_utility_range__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_utility_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_utility_range__);



/**
 * Returns an array of `length` sequential numbers where `center` is in the array's middle index.
 * The array's middle index is considered to be floored result of `length` / 2.
 */
function centeredRange(center, length) {
  var halfLength = length / 2;

  return __WEBPACK_IMPORTED_MODULE_0_lodash_utility_range___default()(center - Math.floor(halfLength), center).concat(__WEBPACK_IMPORTED_MODULE_0_lodash_utility_range___default()(center, center + Math.ceil(halfLength)));
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var isIterateeCall = __webpack_require__(9);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. If `end` is not specified it's
 * set to `start` with `start` then set to `0`. If `end` is less than `start`
 * a zero-length range is created unless a negative `step` is specified.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the new array of numbers.
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
function range(start, end, step) {
  if (step && isIterateeCall(start, end, step)) {
    end = step = undefined;
  }
  start = +start || 0;
  step = step == null ? 1 : (+step || 0);

  if (end == null) {
    end = start;
    start = 0;
  } else {
    end = +end || 0;
  }
  // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
  // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (++index < length) {
    result[index] = start;
    start += step;
  }
  return result;
}

module.exports = range;


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mod_util__ = __webpack_require__(187);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mod_util__["a"]; });


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mod;
// Alternative to the built-in %-operator for modulus operations.
// The %-operator handles negative numbers in an unexpected way.
// http://stackoverflow.com/a/17323608/89594

// Further extended to allow passing an offset to allow sequences
// starting from a different number than 0.

/**
 * @param n dividend
 * @param m divisor
 * @param o offset
 * @returns {number}
 */
function mod(n, m) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  return ((n - o) % m + m) % m + o;
}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input_email__ = __webpack_require__(189);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__input_email__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zip_code__ = __webpack_require__(191);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__zip_code__["a"]; });



/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputEmailValidator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_email_validator__ = __webpack_require__(190);



/**
 * This validator overrides the default angular <input type="email" /> validation
 * with a custom regex that matches our current validation in the Updater API
 */
var InputEmailValidator = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.validators.input-email', []).directive('input', __WEBPACK_IMPORTED_MODULE_1__input_email_validator__["a" /* InputEmailValidator */]);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = InputEmailValidator;
var EMAIL_REGEXP = /^[A-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-\"\\]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

function InputEmailValidator() {
  return {
    restrict: 'E',
    require: '?ngModel',
    // Make sure we run after ngModel
    priority: 2,
    link: link
  };

  function link(scope, element, attrs, ctrl) {
    if (ctrl && ctrl.$validators.email) {
      // Pulled from angular core
      // @ref: https://github.com/angular/angular.js/blob/master/src/ng/directive/input.js#L1420
      ctrl.$validators.email = function (modelValue, viewValue) {
        var value = modelValue || viewValue;
        return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
      };
    }
  }
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZipCodeValidator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zip_code_validator__ = __webpack_require__(192);



var ZipCodeValidator = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('angular-common.validators.zip-code', []).directive('zipCode', __WEBPACK_IMPORTED_MODULE_1__zip_code_validator__["a" /* ZipCodeValidator */]);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZipCodeValidator;
var ZIP_REGEX = /^[0-9]{5}$/;

function ZipCodeValidator() {
  return {
    require: 'ngModel',
    link: link
  };

  function link(scope, element, attrs, ctrl) {
    ctrl.$validators.zipCode = function ($modelValue, $viewValue) {
      var value = $modelValue || $viewValue;
      return !value || ZIP_REGEX.test(value);
    };
  }
}

/***/ })
/******/ ]);